import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type AggregatedItem = {
  __typename?: 'AggregatedItem';
  key?: Maybe<Scalars['String']>;
};

export type AllMapPolygonResponse = {
  __typename?: 'AllMapPolygonResponse';
  count?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<MapDataItem>>>;
};

export type AllNewsResponse = {
  __typename?: 'AllNewsResponse';
  list?: Maybe<Array<Maybe<News>>>;
  total?: Maybe<Scalars['Int']>;
};

export type AllPropertyUnits = {
  __typename?: 'AllPropertyUnits';
  all?: Maybe<Array<Maybe<Property>>>;
};

export type Bs_BoligsokCriteria = {
  __typename?: 'BS_BoligsokCriteria';
  active?: Maybe<Scalars['Boolean']>;
  bedroomsfrom?: Maybe<Scalars['Int']>;
  geo?: Maybe<Bs_GeoOutput>;
  pricefrom?: Maybe<Scalars['Int']>;
  priceto?: Maybe<Scalars['Int']>;
  propertytype?: Maybe<Array<Maybe<Scalars['String']>>>;
  sizefrom?: Maybe<Scalars['Int']>;
  sizeto?: Maybe<Scalars['Int']>;
};

export type Bs_BoligsokFormInput = {
  bedroomsfrom: Scalars['Int'];
  consents: Bs_Consents;
  contactinfo: Bs_ContactInfo;
  coordinates: Bs_Geo;
  price: Bs_Price;
  propertytype: Scalars['String'];
  size: Bs_Size;
};

export type Bs_BoligsokFormResponse = {
  __typename?: 'BS_BoligsokFormResponse';
  hash: Scalars['String'];
  response: Scalars['String'];
};

export type Bs_BoligsokFormUpdateInput = {
  bedroomsfrom: Scalars['Int'];
  coordinates: Bs_Geo;
  hash: Scalars['String'];
  price: Bs_Price;
  propertytype: Scalars['String'];
  size: Bs_Size;
};

export type Bs_Consents = {
  valuation: Scalars['Boolean'];
};

export type Bs_ContactInfo = {
  email: Scalars['String'];
  mobile: Scalars['String'];
  name: Scalars['String'];
  zip: Scalars['String'];
};

export type Bs_Geo = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radius: Scalars['Int'];
};

export type Bs_GeoOutput = {
  __typename?: 'BS_GeoOutput';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radius: Scalars['Int'];
};

export type Bs_MatchingSearchesInput = {
  lat: Scalars['String'];
  lng: Scalars['String'];
  price?: InputMaybe<Scalars['Int']>;
  propertytype: Scalars['String'];
  radius: Scalars['Int'];
  size?: InputMaybe<Scalars['Int']>;
};

export type Bs_MatchingSearchesOutput = {
  __typename?: 'BS_MatchingSearchesOutput';
  matches?: Maybe<Scalars['Int']>;
};

export type Bs_Price = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type Bs_Size = {
  from: Scalars['Int'];
  to: Scalars['Int'];
};

export type Bs_TestResult = {
  __typename?: 'BS_TestResult';
  response?: Maybe<Scalars['String']>;
};

export type Bs_Unsubscribe = {
  __typename?: 'BS_Unsubscribe';
  response: Scalars['String'];
};

export type Bid = {
  __typename?: 'Bid';
  url?: Maybe<Scalars['String']>;
};

export type Broker = {
  __typename?: 'Broker';
  cellphone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  helper?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  naering?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  office?: Maybe<BrokerOffice>;
  path?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  responsible?: Maybe<Scalars['Boolean']>;
  showProperties?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  /**
   * Dette feltet er kun tilgjengelig sammen med eiendom
   * (1 = vanlig, 2 = ansvarlig)
   */
  type?: Maybe<Scalars['Int']>;
  /** Kun tilgjengelig ved henting av eiendom */
  viewLarge?: Maybe<Scalars['Boolean']>;
  /** Kun tilgjengelig ved henting av eiendom */
  wmId?: Maybe<Scalars['Int']>;
};

export type BrokerFilter = {
  /** Show only project brokers */
  projectOnly?: InputMaybe<Scalars['Boolean']>;
};

export type BrokerImage = {
  __typename?: 'BrokerImage';
  full?: Maybe<Scalars['String']>;
  relative?: Maybe<Scalars['String']>;
};

export type BrokerInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
};

export type BrokerOffice = {
  __typename?: 'BrokerOffice';
  info?: Maybe<Office>;
  urltag?: Maybe<Scalars['String']>;
};

export type BrokerOfficeGroupData = {
  __typename?: 'BrokerOfficeGroupData';
  groups?: Maybe<Array<Scalars['String']>>;
  key?: Maybe<Scalars['String']>;
};

export type BrokerOfficeGroupTypes = {
  __typename?: 'BrokerOfficeGroupTypes';
  data?: Maybe<BrokerOfficeGroupData>;
};

export type BrokerOffices = {
  __typename?: 'BrokerOffices';
  list?: Maybe<Array<Maybe<Office>>>;
};

export type BrokerPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type BrokerShowProperties = {
  __typename?: 'BrokerShowProperties';
  show?: Maybe<Scalars['Boolean']>;
};

export type BrokersInput = {
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<BrokerPagination>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type BrokersList = {
  __typename?: 'BrokersList';
  list?: Maybe<Array<Maybe<SingleBroker>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BrukerSamtykker = {
  epost?: InputMaybe<Scalars['String']>;
  navn?: InputMaybe<Scalars['String']>;
  samtykker?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  telefon?: InputMaybe<Scalars['String']>;
  tjeneste?: InputMaybe<Scalars['Int']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Consents = {
  /** WEBMEGLER - Budvarsel-SMS - Jeg ønsker budvarsel på SMS (2901339) */
  budvarsel?: InputMaybe<Scalars['Boolean']>;
  /** REELTIME - Del med utbygger - Og dele min informasjon med utbygger */
  delmedutbygger?: InputMaybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Finansiering - Jeg ønsker tilbud på finansiering fra Nordea og
   * ønsker å bli kontaktet pr. telefon eller e-post (2901343)
   * Denne tolkes som finansiering hos Reeltime og sendes også til Tipsportalen
   */
  finansiering?: InputMaybe<Scalars['Boolean']>;
  /**
   * RT TIL WEBMEGLER - Jeg samtykker til at PrivatMegleren kan sende meg markedsføring på e-post.
   * Dette inkluderer nyhetsbrev, informasjon om kjøpsprosessen,relevante eiendommer og finansiering fra Nordea. (3001530)
   */
  finansieringmarkedsforing?: InputMaybe<Scalars['Boolean']>;
  /** WEBMEGLER - Forsikring - Jeg ønsker tilbud på forsikring (2901344) */
  forsikring?: InputMaybe<Scalars['Boolean']>;
  /** WEBMEGLER - Generell markedsføring - Jeg ønsker å motta eiendomsrelatert informasjon (2901341) */
  generellmarkedsforing?: InputMaybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Kjøp av bolig? - Jeg ønsker å bli kontaktet pr. telefon eller
   * epost i forbindelse med produktet PrivatMegleren KJØP (3000838)
   */
  kjop?: InputMaybe<Scalars['Boolean']>;
  marketingPromo?: InputMaybe<Scalars['Boolean']>;
  /** WEBMEGLER - Oppdateringer - Jeg ønsker å bli holdt oppdatert om eiendommen på telefon, sms eller epost (2901563) */
  oppdateringer?: InputMaybe<Scalars['Boolean']>;
  /**
   * WEBMEGLER - Skal selge bolig - Jeg skal selge bolig og ønsker kontakt med PrivatMegleren (2901342)
   * Denne tolkes også som verdivurdering hos Reeltime og sendes også til Tipsportalen
   */
  skalselgebolig?: InputMaybe<Scalars['Boolean']>;
  /**
   * RT TIL WEBMEGLER - Tips om lignende eiendommer og Generell Markedsføring - om
   * lignende eiendommer som kommer for salg og annen boligrelatert informasjon
   * (2901340, 2901341)
   */
  tipsomlignendeoggenerellmarkedsforing?: InputMaybe<Scalars['Boolean']>;
  /** WEBMEGLER - Tips om likn. eiend. - Jeg ønsker tips om liknende eiendommer (2901340) */
  tipsomliknende?: InputMaybe<Scalars['Boolean']>;
};

export type ContactInput = {
  comment?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageType?: InputMaybe<ContactPageType>;
  path?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum ContactPageType {
  Broker = 'BROKER',
  Office = 'OFFICE'
}

export type ContactResponse = {
  __typename?: 'ContactResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
};

export type Cost = {
  __typename?: 'Cost';
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CountyItem = {
  municipalityArea?: InputMaybe<Array<InputMaybe<MunicipalityAreaItem>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type CustomResponse = {
  __typename?: 'CustomResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DemographItem = {
  __typename?: 'DemographItem';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DestinationImageInput = {
  size?: InputMaybe<ImageSize>;
};

export type DiggerData = {
  __typename?: 'DiggerData';
  address?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sguid?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DiggerId = {
  diggerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<FormType>;
};

export type DiggerSavedResponse = {
  __typename?: 'DiggerSavedResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type District = {
  __typename?: 'District';
  zip?: Maybe<Scalars['String']>;
};

/** Defining type of content by wm_parent_node column */
export enum DocType {
  All = 'all',
  Dsvedlegg = 'dsvedlegg',
  Vedleggsalgsoppgave = 'vedleggsalgsoppgave'
}

export type Document = {
  __typename?: 'Document';
  active?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DsGoodAdvices = {
  __typename?: 'DsGoodAdvices';
  data?: Maybe<DsGoodAdvicesData>;
};

export type DsGoodAdvicesData = {
  __typename?: 'DsGoodAdvicesData';
  hide?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<DsGoodAdvicesItem>>;
  title?: Maybe<Scalars['String']>;
};

export type DsGoodAdvicesItem = {
  __typename?: 'DsGoodAdvicesItem';
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type EnergyLabel = {
  __typename?: 'EnergyLabel';
  color?: Maybe<Scalars['String']>;
  letter?: Maybe<Scalars['String']>;
};

export type Extra = {
  __typename?: 'Extra';
  antallHusholdninger?: Maybe<PeopleCountDemograph>;
  antallPersoner?: Maybe<PeopleCountDemograph>;
  barn?: Maybe<PeopleDemograph>;
  eldre?: Maybe<PeopleDemograph>;
  ensligmedbarn?: Maybe<PeopleDemograph>;
  ensligutenbarn?: Maybe<PeopleDemograph>;
  flerfamilie?: Maybe<PeopleDemograph>;
  parmedbarn?: Maybe<PeopleDemograph>;
  parutenbarn?: Maybe<PeopleDemograph>;
  ung?: Maybe<PeopleDemograph>;
  ungdom?: Maybe<PeopleDemograph>;
  voksen?: Maybe<PeopleDemograph>;
};

export type Filter = {
  broker?: InputMaybe<BrokerFilter>;
  office?: InputMaybe<OfficeFilter>;
  property?: InputMaybe<PropertyFilter>;
};

export type FinancingResponse = {
  __typename?: 'FinancingResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type FinnKriterier = {
  __typename?: 'FinnKriterier';
  iadnavn?: Maybe<Scalars['String']>;
  id_typer?: Maybe<Scalars['Int']>;
  navn?: Maybe<Scalars['String']>;
};

export enum FormType {
  /** Registrering av finansiering */
  Finansiering = 'FINANSIERING',
  /** Registrering av interessenter */
  Interessent = 'INTERESSENT',
  /** Registrering av verdivurderinger */
  Verdivurdering = 'VERDIVURDERING'
}

export type GetAllNewsInput = {
  active?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['Int']>;
  category_type?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  published?: InputMaybe<Scalars['Boolean']>;
  searchType?: InputMaybe<NewsSearchTypes>;
  type?: InputMaybe<NewsType>;
  urltag: Scalars['String'];
};

export type GetNdTextInput = {
  limit?: InputMaybe<Scalars['Int']>;
  officetag?: InputMaybe<Scalars['String']>;
  type: NdTextType;
  urltag?: InputMaybe<Scalars['String']>;
};

export type GetNybyggTextInput = {
  limit?: InputMaybe<Scalars['Int']>;
  officetag?: InputMaybe<Scalars['String']>;
  type: NybyggTextType;
  urltag?: InputMaybe<Scalars['String']>;
};

export type GetPositionInput = {
  slug?: InputMaybe<Scalars['String']>;
};

export type GetPositionResponse = {
  __typename?: 'GetPositionResponse';
  list?: Maybe<Array<Maybe<Position>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GetPositionsInput = {
  pagination: PositionPagination;
  urltag?: InputMaybe<Scalars['String']>;
};

export type GetReferenceResponse = {
  __typename?: 'GetReferenceResponse';
  list?: Maybe<Array<Maybe<Reference>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GetReferencesInput = {
  id?: InputMaybe<Scalars['Int']>;
  pagination: ReferencesPagination;
  type: ReferenceType;
  urltag?: InputMaybe<Scalars['String']>;
};

export type GetSingleNewsInput = {
  category?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  type?: InputMaybe<NewsType>;
  urltag: Scalars['String'];
};

export type GetTextInput = {
  type?: InputMaybe<Scalars['String']>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type GetTextResponse = {
  __typename?: 'GetTextResponse';
  list?: Maybe<Array<Maybe<OfficeGetTextItem>>>;
};

export enum IdentifierType {
  BrokerId = 'BROKER_ID',
  BrokerPath = 'BROKER_PATH',
  OfficeId = 'OFFICE_ID',
  OfficeUrltag = 'OFFICE_URLTAG'
}

export type Image = {
  __typename?: 'Image';
  ai_label?: Maybe<Scalars['String']>;
  ai_percent?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urleksternleverandor?: Maybe<Scalars['String']>;
  urllitebilde?: Maybe<Scalars['String']>;
  urloriginalbilde?: Maybe<Scalars['String']>;
  urlstandardbilde?: Maybe<Scalars['String']>;
  urlstortthumbnail?: Maybe<Scalars['String']>;
  urlthumbnail?: Maybe<Scalars['String']>;
};

export enum ImageSize {
  /** Stort bilde */
  Large = 'large',
  /** Lite bilde */
  Medium = 'medium',
  /** Orginal bilde */
  Original = 'original',
  /** thumbnail */
  Small = 'small'
}

export type InputPropertyHighLighted = {
  oppdragsnummer?: InputMaybe<Scalars['Int']>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type InterestedDataResponse = {
  __typename?: 'InterestedDataResponse';
  ids?: Maybe<Array<Maybe<InterestedTypeItem>>>;
};

export type InterestedResponse = {
  __typename?: 'InterestedResponse';
  data?: Maybe<InterestedDataResponse>;
  success?: Maybe<Scalars['Boolean']>;
};

export type InterestedTypeItem = {
  __typename?: 'InterestedTypeItem';
  data?: Maybe<DiggerData>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type Kriterier = {
  __typename?: 'Kriterier';
  finnMatchekriterier?: Maybe<Array<Maybe<FinnKriterier>>>;
  wmMatchekriterier?: Maybe<Array<Maybe<WmKriterier>>>;
};

export enum LandingPageType {
  Contact = 'CONTACT',
  Cookie = 'COOKIE',
  Home = 'HOME',
  Valuation = 'VALUATION'
}

export type Landingpages = {
  officeId?: InputMaybe<Scalars['Int']>;
  pageType: LandingPageType;
  urltag?: InputMaybe<Scalars['String']>;
};

export type LandingpagesResponse = {
  __typename?: 'LandingpagesResponse';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LeadInput = {
  address?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  consents?: InputMaybe<Consents>;
  diggerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  /**
   * urltag (kontor), sguid (objekt), path (megler)
   * Dersom generell skal identifier ikke være satt.
   */
  identifierType?: InputMaybe<IdentifierType>;
  json?: InputMaybe<Scalars['JSON']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadType: LeadType;
  listType?: InputMaybe<Scalars['String']>;
  mailType?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notify?: InputMaybe<LeadNotify>;
  pageType?: InputMaybe<PageType>;
  phone?: InputMaybe<Scalars['String']>;
  /** Always request origin */
  referer?: InputMaybe<Scalars['String']>;
  /** Absolute url of page where form was submitted from */
  url?: InputMaybe<Scalars['String']>;
  wmId?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type LeadNotify = {
  autoreply?: InputMaybe<Scalars['Boolean']>;
  mail?: InputMaybe<LeadNotifyMail>;
};

export type LeadNotifyMail = {
  bcc?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
};

export type LeadResponse = {
  __typename?: 'LeadResponse';
  contact?: Maybe<ContactResponse>;
  custom?: Maybe<CustomResponse>;
  financing?: Maybe<FinancingResponse>;
  interested?: Maybe<InterestedResponse>;
  mail?: Maybe<MailResponse>;
  soldprice?: Maybe<SoldpriceResponse>;
  valuation?: Maybe<ValuationResponse>;
};


export type LeadResponseSoldpriceArgs = {
  input?: InputMaybe<SoldPriceInput>;
};


export type LeadResponseValuationArgs = {
  input?: InputMaybe<ValuationInput>;
};

export enum LeadType {
  Custom = 'CUSTOM',
  Epost = 'EPOST',
  Finansiering = 'FINANSIERING',
  Interessent = 'INTERESSENT',
  Kontakt = 'KONTAKT',
  Soldprice = 'SOLDPRICE',
  Verdivurdering = 'VERDIVURDERING'
}

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<Coordinates>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  municipalityArea?: Maybe<Scalars['String']>;
  searchLocation?: Maybe<Scalars['String']>;
};

export type MailResponse = {
  __typename?: 'MailResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type MapDataItem = {
  __typename?: 'MapDataItem';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  polygons?: Maybe<Array<Maybe<MapPolygonItem>>>;
  urltag?: Maybe<Scalars['String']>;
  zipcodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum MapObjectType {
  Area = 'Area',
  Office = 'Office',
  Page = 'Page',
  Zipcode = 'Zipcode'
}

export type MapPointItem = {
  __typename?: 'MapPointItem';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type MapPolygonInput = {
  type: MapObjectType;
  value: Scalars['String'];
};

export type MapPolygonItem = {
  __typename?: 'MapPolygonItem';
  points?: Maybe<Array<Maybe<MapPointItem>>>;
  zipcode?: Maybe<Scalars['String']>;
};

export type Matrikkel = {
  __typename?: 'Matrikkel';
  bnr?: Maybe<Scalars['Int']>;
  fnr?: Maybe<Scalars['Int']>;
  gnr?: Maybe<Scalars['Int']>;
  knr?: Maybe<Scalars['Int']>;
  snr?: Maybe<Scalars['Int']>;
  /** Kun tilgjengelig dersom underenhet */
  unit?: Maybe<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  url?: Maybe<Scalars['String']>;
};

export type Menu = {
  __typename?: 'Menu';
  menu?: Maybe<Array<Maybe<MenuElements>>>;
  nybyggmenu?: Maybe<Array<Maybe<MenuElements>>>;
  submenu?: Maybe<Array<Maybe<MenuElements>>>;
};

export type MenuElements = {
  __typename?: 'MenuElements';
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subMenu?: Maybe<Array<Maybe<MenuElements>>>;
};

export type MunicipalityAreaItem = {
  name?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addSamtykke?: Maybe<StandardResponse>;
  boligsokform?: Maybe<Bs_BoligsokFormResponse>;
  deleteNews?: Maybe<UpdateNewsResponse>;
  deletePropertyHighlighted?: Maybe<Scalars['Boolean']>;
  insertPropertyHighLighted?: Maybe<Scalars['Boolean']>;
  lead?: Maybe<LeadResponse>;
  refreshPropertyHighLighted?: Maybe<Scalars['Int']>;
  registerBoligsokWithId?: Maybe<Bs_BoligsokFormResponse>;
  registrerBrukerSamtykke?: Maybe<StandardResponse>;
  saveDiggerId?: Maybe<DiggerSavedResponse>;
  unsubscribe?: Maybe<Bs_Unsubscribe>;
  updateBoligsokform?: Maybe<Bs_BoligsokFormResponse>;
  updateNews?: Maybe<UpdateNewsResponse>;
};


export type MutationAddSamtykkeArgs = {
  input: SamtykkeInput;
};


export type MutationBoligsokformArgs = {
  boligsokFormInput?: InputMaybe<Bs_BoligsokFormInput>;
};


export type MutationDeleteNewsArgs = {
  id: Scalars['Int'];
};


export type MutationDeletePropertyHighlightedArgs = {
  input: InputPropertyHighLighted;
};


export type MutationInsertPropertyHighLightedArgs = {
  input: InputPropertyHighLighted;
};


export type MutationLeadArgs = {
  input: LeadInput;
};


export type MutationRefreshPropertyHighLightedArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterBoligsokWithIdArgs = {
  contactinfo?: InputMaybe<Bs_ContactInfo>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationRegistrerBrukerSamtykkeArgs = {
  input: BrukerSamtykker;
};


export type MutationSaveDiggerIdArgs = {
  input: SaveDiggerInput;
};


export type MutationUnsubscribeArgs = {
  hash?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBoligsokformArgs = {
  boligsokFormInput?: InputMaybe<Bs_BoligsokFormUpdateInput>;
};


export type MutationUpdateNewsArgs = {
  input: NewsInput;
};

export type NdPageConfig = {
  __typename?: 'NdPageConfig';
  showFrontpageNews?: Maybe<Scalars['Boolean']>;
  showFrontpageService?: Maybe<Scalars['Boolean']>;
  showStatistics?: Maybe<Scalars['Boolean']>;
  showSubpageContact?: Maybe<Scalars['Boolean']>;
  showSubpageNews?: Maybe<Scalars['Boolean']>;
  showSubpageProperties?: Maybe<Scalars['Boolean']>;
  showSubpagePropertiesHighlight?: Maybe<Scalars['Boolean']>;
  showSubpageServices?: Maybe<Scalars['Boolean']>;
};

export type NdPageConfigInput = {
  urltag?: InputMaybe<Scalars['String']>;
};

export type NdPageContentInput = {
  type?: InputMaybe<Scalars['String']>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type NdPageItem = {
  __typename?: 'NdPageItem';
  config?: Maybe<NdPageConfig>;
  image?: Maybe<Scalars['String']>;
  imageList?: Maybe<Array<Maybe<NewDevelopmentImage>>>;
  ingress?: Maybe<Scalars['String']>;
  office?: Maybe<NdPageOfficeItem>;
  seo?: Maybe<NdPageSeo>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NdPageOfficeItem = {
  __typename?: 'NdPageOfficeItem';
  name?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
};

export type NdPageSeo = {
  __typename?: 'NdPageSeo';
  image?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NdTextItem = {
  __typename?: 'NdTextItem';
  id?: Maybe<Scalars['Int']>;
  ingress?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<NdTextType>;
  urltag?: Maybe<Scalars['String']>;
};

export enum NdTextType {
  Artikkel = 'ARTIKKEL',
  Kjope = 'KJOPE',
  Kontakt = 'KONTAKT',
  Meglere = 'MEGLERE',
  Nyheter = 'NYHETER',
  Tjenester = 'TJENESTER'
}

export type Neighborhood = {
  __typename?: 'Neighborhood';
  areas?: Maybe<NeighborhoodAreas>;
  demograph?: Maybe<NeighborhoodDemograph>;
  extra?: Maybe<Extra>;
  neighborhood?: Maybe<NeighborhoodInfo>;
  places?: Maybe<NeighborhoodPlace>;
};

export type NeighborhoodAreas = {
  __typename?: 'NeighborhoodAreas';
  grunnkrets?: Maybe<Scalars['String']>;
  kommune?: Maybe<Scalars['String']>;
  norge?: Maybe<Scalars['String']>;
};

export type NeighborhoodDemograph = {
  __typename?: 'NeighborhoodDemograph';
  people?: Maybe<Array<Maybe<DemographItem>>>;
  property?: Maybe<Array<Maybe<DemographItem>>>;
};

export type NeighborhoodInfo = {
  __typename?: 'NeighborhoodInfo';
  ratings?: Maybe<NeighborhoodRatingItems>;
  recommendedFor?: Maybe<Array<Maybe<NeighborhoodInfoItem>>>;
  transport?: Maybe<Array<Maybe<NeighborhoodInfoItem>>>;
};

export type NeighborhoodInfoItem = {
  __typename?: 'NeighborhoodInfoItem';
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

export type NeighborhoodPlace = {
  __typename?: 'NeighborhoodPlace';
  goodsAndServices?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  higherEducation?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  kindergarten?: Maybe<Array<Maybe<NeighborhoodPlaceItemSchool>>>;
  nearby?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  schools?: Maybe<Array<Maybe<NeighborhoodPlaceItemSchool>>>;
  sport?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
  transport?: Maybe<Array<Maybe<NeighborhoodPlaceItem>>>;
};

export type NeighborhoodPlaceDistance = {
  __typename?: 'NeighborhoodPlaceDistance';
  air?: Maybe<Scalars['Float']>;
  drive?: Maybe<Scalars['Float']>;
  selected?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  walk?: Maybe<Scalars['Float']>;
};

export type NeighborhoodPlaceDuration = {
  __typename?: 'NeighborhoodPlaceDuration';
  drive?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  walk?: Maybe<Scalars['Float']>;
};

export type NeighborhoodPlaceItem = {
  __typename?: 'NeighborhoodPlaceItem';
  coordinates?: Maybe<Coordinates>;
  distances?: Maybe<NeighborhoodPlaceDistance>;
  duration?: Maybe<NeighborhoodPlaceDuration>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type NeighborhoodPlaceItemSchool = {
  __typename?: 'NeighborhoodPlaceItemSchool';
  classes?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  distances?: Maybe<NeighborhoodPlaceDistance>;
  duration?: Maybe<NeighborhoodPlaceDuration>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  students?: Maybe<Scalars['String']>;
};

export type NeighborhoodRatingItem = {
  __typename?: 'NeighborhoodRatingItem';
  averageCity?: Maybe<Scalars['String']>;
  averageScore?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  question?: Maybe<NeighborhoodRatingQuestion>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type NeighborhoodRatingItems = {
  __typename?: 'NeighborhoodRatingItems';
  aktiviteter?: Maybe<NeighborhoodRatingItem>;
  kollektivtilbud?: Maybe<NeighborhoodRatingItem>;
  kvalitetskoler?: Maybe<NeighborhoodRatingItem>;
  naboskapet?: Maybe<NeighborhoodRatingItem>;
  shopping?: Maybe<NeighborhoodRatingItem>;
  stoynivaa?: Maybe<NeighborhoodRatingItem>;
  trafikk?: Maybe<NeighborhoodRatingItem>;
  tryggetderbarnaferdes?: Maybe<NeighborhoodRatingItem>;
  trygghet?: Maybe<NeighborhoodRatingItem>;
  turmuligheter?: Maybe<NeighborhoodRatingItem>;
  vedlikeholdhager?: Maybe<NeighborhoodRatingItem>;
};

export type NeighborhoodRatingQuestion = {
  __typename?: 'NeighborhoodRatingQuestion';
  options?: Maybe<Array<Maybe<NeighborhoodRatingQuestionOption>>>;
  text?: Maybe<Scalars['String']>;
};

export type NeighborhoodRatingQuestionOption = {
  __typename?: 'NeighborhoodRatingQuestionOption';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
};

export type NeighborhoodRatingScore = {
  __typename?: 'NeighborhoodRatingScore';
  averageCity?: Maybe<Scalars['String']>;
  averageScore?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type NeighborhoodSchoolInfo = {
  __typename?: 'NeighborhoodSchoolInfo';
  classes?: Maybe<Scalars['String']>;
  students?: Maybe<Scalars['String']>;
};

export type NeighborhoodUrl = {
  __typename?: 'NeighborhoodUrl';
  url?: Maybe<Scalars['String']>;
};

export type NewDevelopmentImage = {
  __typename?: 'NewDevelopmentImage';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  linkTo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type News = {
  __typename?: 'News';
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  imageCategory?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  officetag?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type NewsInput = {
  body: Scalars['String'];
  category: Scalars['Int'];
  externalUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image: Scalars['String'];
  ingress: Scalars['String'];
  publish?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  urltag: Scalars['String'];
};

export enum NewsSearchTypes {
  Nybyggallnews = 'NYBYGGALLNEWS',
  Nybyggfrontpage = 'NYBYGGFRONTPAGE'
}

export enum NewsType {
  Nybyggportal = 'NYBYGGPORTAL'
}

export type NpSearchPropertyInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sold?: InputMaybe<Scalars['Boolean']>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type NpSearchPropertyResult = {
  __typename?: 'NpSearchPropertyResult';
  list?: Maybe<Array<Maybe<SearchProperty>>>;
  total?: Maybe<Scalars['Int']>;
};

export type NybyggText = {
  __typename?: 'NybyggText';
  id?: Maybe<Scalars['Int']>;
  ingress?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<NybyggTextType>;
  urltag?: Maybe<Scalars['String']>;
};

export enum NybyggTextType {
  Artikkel = 'ARTIKKEL',
  Kjope = 'KJOPE',
  Kontakt = 'KONTAKT',
  Meglere = 'MEGLERE',
  Nyheter = 'NYHETER',
  Tjenester = 'TJENESTER'
}

export type ObjectTypeAggregated = {
  key?: InputMaybe<Scalars['String']>;
};

export type Office = {
  __typename?: 'Office';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  brokerShowProperties?: Maybe<Scalars['Boolean']>;
  brokers?: Maybe<OfficeBrokers>;
  coordinates?: Maybe<Coordinates>;
  county?: Maybe<Scalars['String']>;
  /** Only available in search geolocation distance */
  distance?: Maybe<OfficeDistance>;
  districts?: Maybe<OfficeDistricts>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  groupTypes?: Maybe<BrokerOfficeGroupData>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  hasSoldPrice?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  naering?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  newDevelopment?: Maybe<OfficeNewDevelopment>;
  newDevelopmentCustomers?: Maybe<OfficeNewDevelopmentCustomers>;
  newDevelopmentServices?: Maybe<OfficeNewDevelopmentServices>;
  news?: Maybe<OfficeNews>;
  orgnumber?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  pricelist?: Maybe<Scalars['String']>;
  referencesFormText?: Maybe<Scalars['String']>;
  referencesText?: Maybe<Scalars['String']>;
  seo?: Maybe<OfficeSeo>;
  text?: Maybe<Scalars['String']>;
  /** Broker title on each office */
  title?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
  valuationText?: Maybe<Scalars['String']>;
  wmId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  zipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OfficeBrokers = {
  __typename?: 'OfficeBrokers';
  list?: Maybe<Array<Maybe<Broker>>>;
};

export type OfficeCustomers = {
  urltag?: InputMaybe<Scalars['String']>;
};

export type OfficeDistance = {
  __typename?: 'OfficeDistance';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type OfficeDistricts = {
  __typename?: 'OfficeDistricts';
  list?: Maybe<Array<Maybe<District>>>;
};

export type OfficeFilter = {
  geolocation?: InputMaybe<OfficeGeolocation>;
  /** Show only project offices */
  projectOnly?: InputMaybe<Scalars['Boolean']>;
  /** Show all offices */
  showAll?: InputMaybe<Scalars['Boolean']>;
  /** Filter offices by connected zipcodes. */
  zip?: InputMaybe<OfficeZip>;
};

export type OfficeGeolocation = {
  distance?: InputMaybe<Scalars['Float']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<PropertyGeolocationUnit>;
};

export type OfficeGetTextItem = {
  __typename?: 'OfficeGetTextItem';
  avdelings_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
};

export type OfficeGetTexts = {
  __typename?: 'OfficeGetTexts';
  list?: Maybe<Array<Maybe<OfficeGetTextItem>>>;
};

export type OfficeGroup = {
  tag?: InputMaybe<OfficeGroupTypes>;
};

export enum OfficeGroupTypes {
  Leisure = 'LEISURE'
}

export type OfficeInput = {
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OfficeType>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type OfficeNewCustomerItem = {
  __typename?: 'OfficeNewCustomerItem';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  img?: Maybe<Scalars['String']>;
  imgCategory?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OfficeNewDev = {
  __typename?: 'OfficeNewDev';
  broker?: Maybe<OfficeNewDevInfo>;
  buy?: Maybe<OfficeNewDevInfo>;
  contact?: Maybe<OfficeNewDevInfo>;
  contentService?: Maybe<Scalars['String']>;
  customer?: Maybe<OfficeNewDevInfo>;
  customersCoverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionBroker?: Maybe<Scalars['String']>;
  descriptionBuy?: Maybe<Scalars['String']>;
  descriptionNews?: Maybe<Scalars['String']>;
  frontCoverImage?: Maybe<Scalars['String']>;
  frontpage?: Maybe<OfficeNewDevInfo>;
  ingressService?: Maybe<Scalars['String']>;
  news?: Maybe<OfficeNewDevInfo>;
  service?: Maybe<OfficeNewDevInfo>;
  servicesCoverImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleBroker?: Maybe<Scalars['String']>;
  titleService?: Maybe<Scalars['String']>;
};

export type OfficeNewDevInfo = {
  __typename?: 'OfficeNewDevInfo';
  image?: Maybe<Scalars['String']>;
  imageList?: Maybe<Array<Maybe<NewDevelopmentImage>>>;
  ingress?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OfficeNewDevelopment = {
  __typename?: 'OfficeNewDevelopment';
  info?: Maybe<OfficeNewDev>;
};

export type OfficeNewDevelopmentCustomers = {
  __typename?: 'OfficeNewDevelopmentCustomers';
  list?: Maybe<Array<Maybe<OfficeNewCustomerItem>>>;
};

export type OfficeNewDevelopmentServiceItem = {
  __typename?: 'OfficeNewDevelopmentServiceItem';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  img?: Maybe<Scalars['String']>;
  imgCategory?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type OfficeNewDevelopmentServices = {
  __typename?: 'OfficeNewDevelopmentServices';
  list?: Maybe<Array<Maybe<OfficeNewDevelopmentServiceItem>>>;
};

export type OfficeNews = {
  __typename?: 'OfficeNews';
  hasNews?: Maybe<Scalars['Boolean']>;
};

export type OfficePagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type OfficeResponse = {
  __typename?: 'OfficeResponse';
  list?: Maybe<Array<Maybe<Office>>>;
  total?: Maybe<Scalars['Int']>;
};

export type OfficeSeo = {
  __typename?: 'OfficeSeo';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum OfficeType {
  Nybygg = 'NYBYGG'
}

export type OfficeZip = {
  distance?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<PropertyGeolocationUnit>;
  value?: InputMaybe<Scalars['String']>;
};

export type OfficesFilterInput = {
  groups?: InputMaybe<Array<InputMaybe<OfficeGroup>>>;
};

export type OfficesInput = {
  filter?: InputMaybe<OfficesFilterInput>;
  pagination?: InputMaybe<OfficePagination>;
};

export type PageAreas = {
  __typename?: 'PageAreas';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type PageAreasResult = {
  __typename?: 'PageAreasResult';
  count: Scalars['Int'];
  list?: Maybe<Array<PageAreas>>;
};

export type PageBrokersInput = {
  Page?: InputMaybe<Scalars['Int']>;
  areaId: Scalars['Int'];
  from?: InputMaybe<Scalars['Int']>;
  pageUrlTag: Scalars['String'];
};

export type PageBrokersResult = {
  __typename?: 'PageBrokersResult';
  count: Scalars['Int'];
  list?: Maybe<Array<SingleBroker>>;
};

export type PageOfficeResult = {
  __typename?: 'PageOfficeResult';
  count: Scalars['Int'];
  list?: Maybe<Array<Office>>;
};

export enum PageType {
  Generell = 'GENERELL',
  Kampanje = 'KAMPANJE',
  Kontor = 'KONTOR',
  Megler = 'MEGLER',
  Nordeaselgekjope = 'NORDEASELGEKJOPE',
  Objekt = 'OBJEKT',
  Visningspaamelding = 'VISNINGSPAAMELDING'
}

export type PageUrltagInput = {
  value: Scalars['String'];
};

export type ParkingElement = {
  __typename?: 'ParkingElement';
  benevnelse?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  type_salgparkering?: Maybe<Scalars['String']>;
};

export type PeopleCountDemograph = {
  __typename?: 'PeopleCountDemograph';
  grunnkrets?: Maybe<PeopleDemographSubWithValue>;
  kommune?: Maybe<PeopleDemographSubWithValue>;
  label?: Maybe<Scalars['String']>;
  norge?: Maybe<PeopleDemographSubWithValue>;
};

export type PeopleDemograph = {
  __typename?: 'PeopleDemograph';
  grunnkrets?: Maybe<PeopleDemographSub>;
  kommune?: Maybe<PeopleDemographSub>;
  label?: Maybe<Scalars['String']>;
  norge?: Maybe<PeopleDemographSub>;
};

export type PeopleDemographSub = {
  __typename?: 'PeopleDemographSub';
  label?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type PeopleDemographSubWithValue = {
  __typename?: 'PeopleDemographSubWithValue';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Plot = {
  __typename?: 'Plot';
  owner?: Maybe<Scalars['String']>;
  /** Størrelse i m2 */
  size?: Maybe<Scalars['Int']>;
};

export type Position = {
  __typename?: 'Position';
  content?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  info?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  office?: Maybe<PositionOffice>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PositionOffice = {
  __typename?: 'PositionOffice';
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
};

export type PositionPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Price = {
  __typename?: 'Price';
  commonCosts?: Maybe<Scalars['Float']>;
  commonCostsPeriode?: Maybe<Scalars['String']>;
  commonCostsTo?: Maybe<Scalars['Float']>;
  commonExpenses?: Maybe<Scalars['Float']>;
  commonShareDebt?: Maybe<Scalars['Float']>;
  commonShareDebtTo?: Maybe<Scalars['Float']>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  customPriceFrom?: Maybe<Scalars['Float']>;
  customPriceTo?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceTo?: Maybe<Scalars['Float']>;
  taxValue?: Maybe<Scalars['Float']>;
  totalCosts?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceExCosts?: Maybe<Scalars['Float']>;
  totalPriceText?: Maybe<Scalars['String']>;
  totalWithCosts?: Maybe<Scalars['Float']>;
};

export type Properties = {
  __typename?: 'Properties';
  list?: Maybe<Array<Maybe<Property>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PropertiesInput = {
  broker?: InputMaybe<PropertiesInputBroker>;
  office?: InputMaybe<PropertiesInputOffice>;
  pagination?: InputMaybe<PropertyPagination>;
  saleType?: InputMaybe<Array<InputMaybe<PropertySaleType>>>;
  sold?: InputMaybe<Scalars['Boolean']>;
};

export type PropertiesInputBroker = {
  id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['String']>;
};

export type PropertiesInputOffice = {
  id?: InputMaybe<Scalars['Int']>;
  urltag?: InputMaybe<Scalars['String']>;
  urltagArr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Property = {
  __typename?: 'Property';
  accepted?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  allDocuments?: Maybe<PropertyAllDocuments>;
  area?: Maybe<PropertyArea>;
  assignmentType?: Maybe<Scalars['String']>;
  bedrooms?: Maybe<Scalars['Int']>;
  bedroomsTo?: Maybe<Scalars['Int']>;
  bid?: Maybe<PropertyBid>;
  brokers?: Maybe<PropertyAgents>;
  buildYear?: Maybe<Scalars['String']>;
  checklistpoints?: Maybe<PropertyChecklistPoints>;
  created?: Maybe<Scalars['String']>;
  /** Overskrift i webmegler_object_cache */
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<PropertyDocuments>;
  environment?: Maybe<PropertyEnvironment>;
  estateSummary?: Maybe<PropertyEstateSummary>;
  floor?: Maybe<Scalars['Int']>;
  freetext?: Maybe<PropertyFreeText>;
  goodadvices?: Maybe<DsGoodAdvices>;
  /** Markedsføringsklart */
  highlighted?: Maybe<Array<Maybe<PropertyHighlighted>>>;
  hovedoppdrag?: Maybe<Scalars['Int']>;
  /** Hent ut id til hovedoppdrag på underenheter */
  hovedoppdragId?: Maybe<PropertyHovedoppdrag>;
  id?: Maybe<Scalars['String']>;
  id_oppdrag_prosjekt?: Maybe<Scalars['String']>;
  images?: Maybe<PropertyImages>;
  insurance?: Maybe<PropertyInsurance>;
  links?: Maybe<PropertyLinks>;
  location?: Maybe<Location>;
  matchekriterier?: Maybe<PropertyMatchekriterier>;
  matrikkel?: Maybe<PropertyMatrikkel>;
  modified?: Maybe<Scalars['String']>;
  naering?: Maybe<Scalars['Boolean']>;
  neighborhood?: Maybe<PropertyNeighborhood>;
  newDevelopment?: Maybe<PropertyNewDevelopment>;
  nybygg?: Maybe<PropertyNybygg>;
  office?: Maybe<PropertyOffice>;
  ownerType?: Maybe<Scalars['String']>;
  parking?: Maybe<PropertyParking>;
  /**
   * Type oppdrag
   * (1 = nybygg, 2 = brukt og 3 = fritid)
   */
  permalink?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  plot?: Maybe<PropertyPlot>;
  preview?: Maybe<Scalars['Boolean']>;
  previewUpdated?: Maybe<Scalars['Boolean']>;
  price?: Maybe<PropertyPrice>;
  projectLogos?: Maybe<PropertyProjectLogos>;
  prospect?: Maybe<PropertyProspect>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['String']>;
  reserved?: Maybe<Scalars['Boolean']>;
  rooms?: Maybe<Scalars['Int']>;
  salgsoppgaveArkiv?: Maybe<PropertySalgsoppgaveArkiv>;
  sold?: Maybe<Scalars['Boolean']>;
  soldDate?: Maybe<Scalars['String']>;
  /** Prosjekt i webmegler_object_cache */
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typeNumber?: Maybe<Scalars['Int']>;
  units?: Maybe<PropertyUnits>;
  video?: Maybe<PropertyVideo>;
  viewing3d?: Maybe<Property3dViewing>;
  viewings?: Maybe<PropertyViewings>;
  wmId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Property3dViewing = {
  __typename?: 'Property3dViewing';
  info?: Maybe<Media>;
};

export type PropertyAgents = {
  __typename?: 'PropertyAgents';
  list?: Maybe<Array<Maybe<Broker>>>;
  responsible?: Maybe<Broker>;
};

export type PropertyAggregationType = {
  __typename?: 'PropertyAggregationType';
  doc_count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyAggregations = {
  __typename?: 'PropertyAggregations';
  assignmentTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  counties?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  facilityTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  locationTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  municipalities?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  municipalityAreas?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  places?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  propertyTypes?: Maybe<Array<Maybe<PropertyAggregationType>>>;
  sold?: Maybe<Array<Maybe<PropertyAggregationType>>>;
};

export type PropertyAllDocuments = {
  __typename?: 'PropertyAllDocuments';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertyArea = {
  __typename?: 'PropertyArea';
  /** Bruksareal */
  bra?: Maybe<Scalars['String']>;
  /** Bruksareal til */
  braTo?: Maybe<Scalars['String']>;
  /** bruksareal balkong */
  brab?: Maybe<Scalars['String']>;
  /** bruksareal balkong til */
  brabTo?: Maybe<Scalars['String']>;
  /** eksternt bruksareal. */
  brae?: Maybe<Scalars['String']>;
  /** eksternt bruksareal til. */
  braeTo?: Maybe<Scalars['String']>;
  /** internt bruksareal. */
  brai?: Maybe<Scalars['String']>;
  /** internt bruksareal til. */
  braiTo?: Maybe<Scalars['String']>;
  /** Bruttoareal */
  bta?: Maybe<Scalars['String']>;
  /** Bruttoareal til */
  btaTo?: Maybe<Scalars['String']>;
  /** åpent areal */
  oa?: Maybe<Scalars['String']>;
  /** åpent areal til */
  oaTo?: Maybe<Scalars['String']>;
  /** Primærrom */
  prom?: Maybe<Scalars['String']>;
  /** Primærrom til */
  promTo?: Maybe<Scalars['String']>;
};

export enum PropertyAttachmentType {
  DsVedlegg = 'ds_vedlegg',
  VedleggSalgsoppgave = 'vedlegg_salgsoppgave'
}

export type PropertyBid = {
  __typename?: 'PropertyBid';
  link?: Maybe<Bid>;
};

export type PropertyChecklistPoints = {
  __typename?: 'PropertyChecklistPoints';
  info?: Maybe<PropertyChecklistPointsInfo>;
};

export type PropertyChecklistPointsInfo = {
  __typename?: 'PropertyChecklistPointsInfo';
  dobbeltBoligforsikring?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['Boolean']>;
  pmExclusive?: Maybe<Scalars['Boolean']>;
  teaser?: Maybe<Scalars['Boolean']>;
  useScaledVersion?: Maybe<Scalars['Boolean']>;
};

export type PropertyDocuments = {
  __typename?: 'PropertyDocuments';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertyEnvironment = {
  __typename?: 'PropertyEnvironment';
  energyLabel?: Maybe<EnergyLabel>;
};

export type PropertyEstateSummary = {
  __typename?: 'PropertyEstateSummary';
  info?: Maybe<Scalars['String']>;
};

export type PropertyFilter = {
  available?: InputMaybe<Scalars['Boolean']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  brokerId?: InputMaybe<Scalars['Int']>;
  brokerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /**
   * Sett til true dersom du kun ønsker å vise eiendommer
   * som har PrivatMegleren Eksklusiv, og sett til false dersom
   * du ikke ønsker Eksklusive eiendommer. Dersom ikke definert vil
   * den ikke ta hensyn til dette.
   */
  exclusive?: InputMaybe<Scalars['Boolean']>;
  facilityTypeAggregated?: InputMaybe<PropertyFilterAggregated>;
  geolocation?: InputMaybe<PropertyGeolocation>;
  highlighted?: InputMaybe<Scalars['Boolean']>;
  includeAccepted?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Array<InputMaybe<PropertySearchLocationItem>>>;
  locationTypeAggregated?: InputMaybe<PropertyFilterAggregated>;
  objectType?: InputMaybe<PropertyFilterObjectType>;
  objectTypeAggregated?: InputMaybe<PropertyFilterObjectTypeAggregated>;
  officeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  price?: InputMaybe<PropertyFilterPrice>;
  saleType?: InputMaybe<Array<InputMaybe<PropertySaleType>>>;
  size?: InputMaybe<PropertyFilterSize>;
  sold?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<PropertySortByType>;
  subLocations?: InputMaybe<Array<InputMaybe<PropertySearchSubLocationItem>>>;
  urltag?: InputMaybe<Scalars['String']>;
  urltagArr?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PropertyFilterAggregated = {
  types?: InputMaybe<Array<InputMaybe<TypeAggregated>>>;
};

export type PropertyFilterObjectType = {
  annet?: InputMaybe<Scalars['Boolean']>;
  bygaard?: InputMaybe<Scalars['Boolean']>;
  enebolig?: InputMaybe<Scalars['Boolean']>;
  fritid?: InputMaybe<Scalars['Boolean']>;
  gaardsbruk?: InputMaybe<Scalars['Boolean']>;
  garasjeparkering?: InputMaybe<Scalars['Boolean']>;
  hybel?: InputMaybe<Scalars['Boolean']>;
  hytte?: InputMaybe<Scalars['Boolean']>;
  hyttetomt?: InputMaybe<Scalars['Boolean']>;
  leilighet?: InputMaybe<Scalars['Boolean']>;
  produksjonindustri?: InputMaybe<Scalars['Boolean']>;
  rekkehus?: InputMaybe<Scalars['Boolean']>;
  romibofelleskap?: InputMaybe<Scalars['Boolean']>;
  tomannsbolig?: InputMaybe<Scalars['Boolean']>;
  tomter?: InputMaybe<Scalars['Boolean']>;
};

export type PropertyFilterObjectTypeAggregated = {
  types?: InputMaybe<Array<InputMaybe<ObjectTypeAggregated>>>;
};

export type PropertyFilterPrice = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type PropertyFilterSize = {
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type PropertyFreeText = {
  __typename?: 'PropertyFreeText';
  list?: Maybe<PropertyFreeTextType>;
};

export type PropertyFreeTextItem = {
  __typename?: 'PropertyFreeTextItem';
  groupname?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type PropertyFreeTextType = {
  __typename?: 'PropertyFreeTextType';
  all?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  buyRelations?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  commonAreaAndGarden?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  cooperatives?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  economy?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  extra?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  finnLocalArea?: Maybe<Scalars['String']>;
  jointOwnership?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  jointStockOwnership?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  keyInformation?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  location?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  projectMain?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  propertyAndGarden?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  publicRelations?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  rightsAndDuties?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  settlement?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
  various?: Maybe<Array<Maybe<PropertyFreeTextItem>>>;
};

export type PropertyGeolocation = {
  distance?: InputMaybe<Scalars['Float']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<PropertyGeolocationUnit>;
};

export enum PropertyGeolocationUnit {
  Km = 'km',
  M = 'm'
}

export type PropertyHasEstatePicker = {
  __typename?: 'PropertyHasEstatePicker';
  external?: Maybe<Scalars['String']>;
  rt?: Maybe<Scalars['Boolean']>;
};

export type PropertyHighLightedInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  sold?: InputMaybe<Scalars['Boolean']>;
  urltag?: InputMaybe<Scalars['String']>;
};

export type PropertyHighLightedItem = {
  __typename?: 'PropertyHighLightedItem';
  oppdragsnummer?: Maybe<Scalars['String']>;
  urltag?: Maybe<Scalars['String']>;
};

export type PropertyHighlighted = {
  __typename?: 'PropertyHighlighted';
  type?: Maybe<Scalars['String']>;
};

export type PropertyHovedoppdrag = {
  __typename?: 'PropertyHovedoppdrag';
  id?: Maybe<Scalars['Int']>;
};

export type PropertyImages = {
  __typename?: 'PropertyImages';
  all?: Maybe<Array<Maybe<Image>>>;
  destination?: Maybe<Image>;
  first?: Maybe<Image>;
  floorplan?: Maybe<Array<Maybe<Image>>>;
  list?: Maybe<Array<Maybe<Image>>>;
};


export type PropertyImagesDestinationArgs = {
  input?: InputMaybe<DestinationImageInput>;
};

export type PropertyInput = {
  attachmentType?: InputMaybe<PropertyAttachmentType>;
  /** Hent eiendommer som er akseptert */
  includeAccepted?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /** Hent eiendommer som ikke er markedsføringsklare. */
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeUnits?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  sguid: Scalars['String'];
  sold?: InputMaybe<Scalars['Boolean']>;
};

export type PropertyInsurance = {
  __typename?: 'PropertyInsurance';
  info?: Maybe<PropertyInsuranceInfo>;
};

export type PropertyInsuranceInfo = {
  __typename?: 'PropertyInsuranceInfo';
  help?: Maybe<Scalars['Boolean']>;
  soderberg?: Maybe<Scalars['Boolean']>;
};

export type PropertyLink = {
  __typename?: 'PropertyLink';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PropertyLinks = {
  __typename?: 'PropertyLinks';
  list?: Maybe<Array<Maybe<PropertyLink>>>;
};

export type PropertyMatchekriterier = {
  __typename?: 'PropertyMatchekriterier';
  kriterier?: Maybe<Kriterier>;
};

export type PropertyMatrikkel = {
  __typename?: 'PropertyMatrikkel';
  info?: Maybe<Matrikkel>;
};

export type PropertyNeighborhood = {
  __typename?: 'PropertyNeighborhood';
  list?: Maybe<Neighborhood>;
  profile?: Maybe<NeighborhoodUrl>;
};

export type PropertyNewDevelopment = {
  __typename?: 'PropertyNewDevelopment';
  estatePicker?: Maybe<PropertyNewDevelopmentEstatePicker>;
  showPriceList?: Maybe<Scalars['Boolean']>;
};

export type PropertyNewDevelopmentEstatePicker = {
  __typename?: 'PropertyNewDevelopmentEstatePicker';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PropertyNybygg = {
  __typename?: 'PropertyNybygg';
  boligvelger?: Maybe<PropertyHasEstatePicker>;
  profile?: Maybe<Scalars['Int']>;
  showPriceList?: Maybe<Scalars['Boolean']>;
};

export type PropertyOffice = {
  __typename?: 'PropertyOffice';
  info?: Maybe<Office>;
};

export type PropertyPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type PropertyParking = {
  __typename?: 'PropertyParking';
  list?: Maybe<Array<Maybe<ParkingElement>>>;
};

export type PropertyPlot = {
  __typename?: 'PropertyPlot';
  info?: Maybe<Plot>;
};

export type PropertyPrice = {
  __typename?: 'PropertyPrice';
  info?: Maybe<Price>;
};

export type PropertyProjectLogo = {
  __typename?: 'PropertyProjectLogo';
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type PropertyProjectLogos = {
  __typename?: 'PropertyProjectLogos';
  list?: Maybe<Array<Maybe<PropertyProjectLogo>>>;
};

export type PropertyProspect = {
  __typename?: 'PropertyProspect';
  info?: Maybe<PropertyProspectUrl>;
};

export type PropertyProspectUrl = {
  __typename?: 'PropertyProspectUrl';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum PropertySaleType {
  Brukt = 'BRUKT',
  Fritid = 'FRITID',
  Fritidutleie = 'FRITIDUTLEIE',
  Naering = 'NAERING',
  Naeringutleie = 'NAERINGUTLEIE',
  Nybygg = 'NYBYGG'
}

export type PropertySalgsoppgaveArkiv = {
  __typename?: 'PropertySalgsoppgaveArkiv';
  list?: Maybe<Array<Maybe<Document>>>;
};

export type PropertySearchLocationItem = {
  county?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<PropertySearchSubLocationItem>>>;
};

export type PropertySearchSubLocationItem = {
  county?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  municipalityArea?: InputMaybe<Scalars['String']>;
};

export enum PropertySortByType {
  Distanceasc = 'DISTANCEASC',
  Distancedesc = 'DISTANCEDESC',
  Pricehighlow = 'PRICEHIGHLOW',
  Pricelowhigh = 'PRICELOWHIGH',
  Publishednewold = 'PUBLISHEDNEWOLD',
  Publishedoldnew = 'PUBLISHEDOLDNEW',
  Recentlysold = 'RECENTLYSOLD',
  Sizehighlow = 'SIZEHIGHLOW',
  Sizelowhigh = 'SIZELOWHIGH',
  Viewingthisweek = 'VIEWINGTHISWEEK',
  Viewingtoday = 'VIEWINGTODAY',
  Viewingtomorrow = 'VIEWINGTOMORROW'
}

export type PropertyUnits = {
  __typename?: 'PropertyUnits';
  available?: Maybe<Scalars['Int']>;
  list?: Maybe<AllPropertyUnits>;
  sold?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PropertyVideo = {
  __typename?: 'PropertyVideo';
  info?: Maybe<Media>;
};

export type PropertyViewings = {
  __typename?: 'PropertyViewings';
  list?: Maybe<Array<Maybe<View>>>;
};

export type Query = {
  __typename?: 'Query';
  boligsokByHash?: Maybe<Bs_BoligsokCriteria>;
  findMatchingSearches: Bs_MatchingSearchesOutput;
  getAllCounties?: Maybe<SearchLocationsResult>;
  getAllNews?: Maybe<AllNewsResponse>;
  getAvailableSamtykker?: Maybe<Array<Maybe<SamtykkeContainerResponse>>>;
  getAvailableSamtykkerByIds?: Maybe<Array<Maybe<SamtykkeContainerResponse>>>;
  getBroker?: Maybe<SingleBroker>;
  getBrokers?: Maybe<BrokersList>;
  getMapPolygons?: Maybe<AllMapPolygonResponse>;
  getMenu?: Maybe<Menu>;
  getMunicipalities?: Maybe<SearchLocationsResult>;
  getNdPageConfig?: Maybe<NdPageConfig>;
  getNdPageContent?: Maybe<NdPageItem>;
  getNewDevelopmentText?: Maybe<Array<Maybe<NdTextItem>>>;
  getNybyggPortalSearchProperties?: Maybe<NpSearchPropertyResult>;
  getNybyggText?: Maybe<Array<Maybe<NybyggText>>>;
  getOffice?: Maybe<Office>;
  getOffices?: Maybe<OfficeResponse>;
  getPageMapAreaBrokers: PageBrokersResult;
  getPageMapAreas: PageAreasResult;
  getPageOffices: PageOfficeResult;
  getPosition?: Maybe<Position>;
  getPositions?: Maybe<GetPositionResponse>;
  getProperties?: Maybe<Properties>;
  getProperty?: Maybe<Property>;
  getPropertyHighLighted?: Maybe<Properties>;
  getQuizPage?: Maybe<QuizPage>;
  getQuizQuestions?: Maybe<Array<Maybe<QuizQuestion>>>;
  getReferences?: Maybe<GetReferenceResponse>;
  getSamtykkeByUser?: Maybe<SamtykkeResponse>;
  getSingleNews?: Maybe<SingleNewsResponse>;
  getTexts?: Maybe<GetTextResponse>;
  landingpages?: Maybe<LandingpagesResponse>;
  leadServiceVersion?: Maybe<Scalars['String']>;
  search?: Maybe<SearchResult>;
};


export type QueryBoligsokByHashArgs = {
  hash?: InputMaybe<Scalars['String']>;
};


export type QueryFindMatchingSearchesArgs = {
  input: Bs_MatchingSearchesInput;
};


export type QueryGetAllNewsArgs = {
  input: GetAllNewsInput;
};


export type QueryGetAvailableSamtykkerByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetBrokerArgs = {
  input?: InputMaybe<BrokerInput>;
};


export type QueryGetBrokersArgs = {
  input?: InputMaybe<BrokersInput>;
};


export type QueryGetMapPolygonsArgs = {
  input: MapPolygonInput;
};


export type QueryGetMunicipalitiesArgs = {
  counties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useArea?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetNdPageConfigArgs = {
  input: NdPageConfigInput;
};


export type QueryGetNdPageContentArgs = {
  input: NdPageContentInput;
};


export type QueryGetNewDevelopmentTextArgs = {
  input: GetNdTextInput;
};


export type QueryGetNybyggPortalSearchPropertiesArgs = {
  input: NpSearchPropertyInput;
};


export type QueryGetNybyggTextArgs = {
  input: GetNybyggTextInput;
};


export type QueryGetOfficeArgs = {
  input?: InputMaybe<OfficeInput>;
};


export type QueryGetOfficesArgs = {
  input?: InputMaybe<OfficesInput>;
};


export type QueryGetPageMapAreaBrokersArgs = {
  input: PageBrokersInput;
};


export type QueryGetPageMapAreasArgs = {
  input: PageUrltagInput;
};


export type QueryGetPageOfficesArgs = {
  input: PageUrltagInput;
};


export type QueryGetPositionArgs = {
  input: GetPositionInput;
};


export type QueryGetPositionsArgs = {
  input: GetPositionsInput;
};


export type QueryGetPropertiesArgs = {
  input?: InputMaybe<PropertiesInput>;
};


export type QueryGetPropertyArgs = {
  input?: InputMaybe<PropertyInput>;
};


export type QueryGetPropertyHighLightedArgs = {
  input: PropertyHighLightedInput;
};


export type QueryGetQuizPageArgs = {
  input: QuizInput;
};


export type QueryGetQuizQuestionsArgs = {
  input: QuizQuestionsInput;
};


export type QueryGetReferencesArgs = {
  input: GetReferencesInput;
};


export type QueryGetSingleNewsArgs = {
  input: GetSingleNewsInput;
};


export type QueryGetTextsArgs = {
  input?: InputMaybe<GetTextInput>;
};


export type QueryLandingpagesArgs = {
  input?: InputMaybe<Landingpages>;
};


export type QuerySearchArgs = {
  input?: InputMaybe<SearchInput>;
};

export type QuizInput = {
  urltag?: InputMaybe<Scalars['String']>;
};

export type QuizOption = {
  __typename?: 'QuizOption';
  id?: Maybe<Scalars['Int']>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  letter?: Maybe<Scalars['String']>;
  pos?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type QuizPage = {
  __typename?: 'QuizPage';
  active?: Maybe<Scalars['Boolean']>;
  formZipcode?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  mailType?: Maybe<Scalars['Int']>;
  pageEnd?: Maybe<QuizPageContent>;
  pageInit?: Maybe<QuizPageContent>;
  pageThankyou?: Maybe<QuizPageContent>;
  privacyPolicy?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['String']>;
  seo?: Maybe<QuizPageSeo>;
};

export type QuizPageContent = {
  __typename?: 'QuizPageContent';
  content?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type QuizPageSeo = {
  __typename?: 'QuizPageSeo';
  content?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type QuizQuestion = {
  __typename?: 'QuizQuestion';
  options?: Maybe<Array<Maybe<QuizOption>>>;
  pos?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type QuizQuestionsInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Reference = {
  __typename?: 'Reference';
  address?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum ReferenceType {
  Broker = 'BROKER',
  Office = 'OFFICE'
}

export type ReferencesPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Seo = {
  __typename?: 'SEO';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Samtykke = {
  __typename?: 'Samtykke';
  beskrivelse?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  samtykke?: Maybe<Scalars['String']>;
};

export type SamtykkeContainerResponse = {
  __typename?: 'SamtykkeContainerResponse';
  id?: Maybe<Scalars['Int']>;
  samtykker?: Maybe<Array<Maybe<Samtykke>>>;
  samtykketekst?: Maybe<Scalars['String']>;
  varighetmnd?: Maybe<Scalars['Int']>;
};

export type SamtykkeInput = {
  text?: InputMaybe<Scalars['String']>;
  varighet?: InputMaybe<Scalars['Int']>;
};

export type SamtykkeResponse = {
  __typename?: 'SamtykkeResponse';
  samtykker?: Maybe<Array<Maybe<Samtykke>>>;
  user?: Maybe<Scalars['String']>;
};

export type SaveDiggerInput = {
  diggerId?: InputMaybe<Scalars['String']>;
  diggerIds?: InputMaybe<Array<InputMaybe<DiggerId>>>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FormType>;
};

export type SearchBroker = {
  __typename?: 'SearchBroker';
  active?: Maybe<Scalars['Boolean']>;
  cellphone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  naering?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  office?: Maybe<Array<Maybe<Office>>>;
  path?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type SearchChecklistPoints = {
  __typename?: 'SearchChecklistPoints';
  dobbeltBoligforsikring?: Maybe<Scalars['Boolean']>;
  pmExclusive?: Maybe<Scalars['Boolean']>;
  teaser?: Maybe<Scalars['Boolean']>;
  useScaledVersion?: Maybe<Scalars['Boolean']>;
};

export type SearchChecklistPointsInfo = {
  __typename?: 'SearchChecklistPointsInfo';
  info?: Maybe<SearchChecklistPoints>;
};

export type SearchInput = {
  filter?: InputMaybe<Filter>;
  query?: InputMaybe<Scalars['String']>;
  searchIn: Array<InputMaybe<SearchInputType>>;
};

export type SearchInputType = {
  pagination: SearchPagination;
  type: SearchTypes;
};

export type SearchLocationsResult = {
  __typename?: 'SearchLocationsResult';
  list?: Maybe<Array<Maybe<AggregatedItem>>>;
};

export type SearchPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type SearchProperty = {
  __typename?: 'SearchProperty';
  address?: Maybe<Scalars['String']>;
  area?: Maybe<PropertyArea>;
  assignmentType?: Maybe<Scalars['String']>;
  bedrooms?: Maybe<Scalars['Int']>;
  bid?: Maybe<PropertyBid>;
  brokers?: Maybe<PropertyAgents>;
  buildYear?: Maybe<Scalars['String']>;
  checklistpoints?: Maybe<SearchChecklistPointsInfo>;
  created?: Maybe<Scalars['String']>;
  /** Overskrift in webmegler_object_cache */
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<PropertyDocuments>;
  environment?: Maybe<PropertyEnvironment>;
  floor?: Maybe<Scalars['Int']>;
  freetext?: Maybe<PropertyFreeText>;
  highlighted?: Maybe<Array<Maybe<PropertyHighlighted>>>;
  id?: Maybe<Scalars['String']>;
  images?: Maybe<SearchPropertyImages>;
  links?: Maybe<PropertyLinks>;
  location?: Maybe<Location>;
  matrikkel?: Maybe<PropertyMatrikkel>;
  modified?: Maybe<Scalars['String']>;
  naering?: Maybe<Scalars['Boolean']>;
  neighborhood?: Maybe<PropertyNeighborhood>;
  office?: Maybe<PropertyOffice>;
  ownerType?: Maybe<Scalars['String']>;
  /**
   * Type oppdrag
   * (1 = nybygg, 2 = brukt og 3 = fritid)
   */
  permalink?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  plot?: Maybe<PropertyPlot>;
  preview?: Maybe<Scalars['Boolean']>;
  previewUpdated?: Maybe<Scalars['Boolean']>;
  price?: Maybe<PropertyPrice>;
  published?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['String']>;
  rooms?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Boolean']>;
  /** Prosjekt in webmegler_object_cache */
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typeNumber?: Maybe<Scalars['Int']>;
  units?: Maybe<PropertyUnits>;
  video?: Maybe<PropertyVideo>;
  viewing3d?: Maybe<Property3dViewing>;
  viewings?: Maybe<PropertyViewings>;
  zip?: Maybe<Scalars['String']>;
};

export type SearchPropertyImage = {
  __typename?: 'SearchPropertyImage';
  url?: Maybe<Scalars['String']>;
};

export type SearchPropertyImages = {
  __typename?: 'SearchPropertyImages';
  first?: Maybe<SearchPropertyImage>;
  list?: Maybe<Array<Maybe<Image>>>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  result?: Maybe<SearchResultSub>;
};

export type SearchResultBrokers = {
  __typename?: 'SearchResultBrokers';
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<SearchBroker>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultLandingpages = {
  __typename?: 'SearchResultLandingpages';
  list?: Maybe<Array<Maybe<Scalars['String']>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultOffices = {
  __typename?: 'SearchResultOffices';
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Office>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultProperties = {
  __typename?: 'SearchResultProperties';
  aggregations?: Maybe<PropertyAggregations>;
  currentPage?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<SearchProperty>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultSub = {
  __typename?: 'SearchResultSub';
  brokers?: Maybe<SearchResultBrokers>;
  landingpages?: Maybe<SearchResultLandingpages>;
  offices?: Maybe<SearchResultOffices>;
  properties?: Maybe<SearchResultProperties>;
};

export enum SearchTypes {
  Broker = 'broker',
  Landingpage = 'landingpage',
  Office = 'office',
  Property = 'property'
}

export type SingleBroker = {
  __typename?: 'SingleBroker';
  cellphone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  groupTypes?: Maybe<BrokerOfficeGroupTypes>;
  helper?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<BrokerImage>;
  naering?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  offices?: Maybe<BrokerOffices>;
  path?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  properties?: Maybe<BrokerShowProperties>;
  title?: Maybe<Scalars['String']>;
};

export type SingleNewsResponse = {
  __typename?: 'SingleNewsResponse';
  body?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Int']>;
  externalUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  imageCategory?: Maybe<Scalars['String']>;
  imageDescriptionBottom?: Maybe<Scalars['String']>;
  imageDescriptionTop?: Maybe<Scalars['String']>;
  ingress?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SoldPriceConsents = {
  /** Post lead to tp (used for Oslo) */
  contactNearby?: InputMaybe<Scalars['Boolean']>;
};

export type SoldPriceInput = {
  consents?: InputMaybe<SoldPriceConsents>;
};

export type SoldpriceResponse = {
  __typename?: 'SoldpriceResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type StandardResponse = {
  __typename?: 'StandardResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type TypeAggregated = {
  key?: InputMaybe<Scalars['String']>;
};

export type UpdateNewsResponse = {
  __typename?: 'UpdateNewsResponse';
  id?: Maybe<Scalars['Int']>;
};

export type UpdatePropertyHighLighted = {
  __typename?: 'UpdatePropertyHighLighted';
  id?: Maybe<Scalars['Int']>;
};

export type ValuationInput = {
  address?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  consents?: InputMaybe<Consents>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pageType?: InputMaybe<PageType>;
  phone?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ValuationResponse = {
  __typename?: 'ValuationResponse';
  /** Lead data for digger */
  data?: Maybe<DiggerData>;
  success?: Maybe<Scalars['Boolean']>;
};

export type View = {
  __typename?: 'View';
  comment?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  startDateTime?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type WmKriterier = {
  __typename?: 'WMKriterier';
  id_typer?: Maybe<Scalars['Int']>;
  navn?: Maybe<Scalars['String']>;
  nr?: Maybe<Scalars['Int']>;
};

export type LeadBoliglaanFinancingMutationVariables = Exact<{
  input: LeadInput;
}>;


export type LeadBoliglaanFinancingMutation = { __typename?: 'Mutation', lead?: { __typename?: 'LeadResponse', financing?: { __typename?: 'FinancingResponse', success?: boolean | null } | null } | null };

export type MailMutationVariables = Exact<{
  input: LeadInput;
}>;


export type MailMutation = { __typename?: 'Mutation', lead?: { __typename?: 'LeadResponse', mail?: { __typename?: 'MailResponse', success?: boolean | null } | null } | null };

export type OfficeValuationMutationVariables = Exact<{
  input: LeadInput;
}>;


export type OfficeValuationMutation = { __typename?: 'Mutation', lead?: { __typename?: 'LeadResponse', valuation?: { __typename?: 'ValuationResponse', success?: boolean | null } | null } | null };

export type RegistrerBrukerSamtykkeMutationVariables = Exact<{
  input: BrukerSamtykker;
}>;


export type RegistrerBrukerSamtykkeMutation = { __typename?: 'Mutation', registrerBrukerSamtykke?: { __typename?: 'StandardResponse', success?: boolean | null } | null };

export type GeneralValuationMutationVariables = Exact<{
  input: LeadInput;
}>;


export type GeneralValuationMutation = { __typename?: 'Mutation', lead?: { __typename?: 'LeadResponse', valuation?: { __typename?: 'ValuationResponse', success?: boolean | null, data?: { __typename?: 'DiggerData', id?: string | null, address?: string | null, zip?: string | null, phone?: string | null, email?: string | null } | null } | null } | null };

export type BrokerQueryVariables = Exact<{
  input?: InputMaybe<BrokerInput>;
}>;


export type BrokerQuery = { __typename?: 'Query', broker?: { __typename?: 'SingleBroker', id?: string | null, name?: string | null, title?: string | null, email?: string | null, cellphone?: string | null, path?: string | null, helper?: boolean | null, properties?: { __typename?: 'BrokerShowProperties', show?: boolean | null } | null, offices?: { __typename?: 'BrokerOffices', list?: Array<{ __typename?: 'Office', title?: string | null, name?: string | null, urltag?: string | null, naering?: boolean | null } | null> | null } | null, image?: { __typename?: 'BrokerImage', full?: string | null } | null, groupTypes?: { __typename?: 'BrokerOfficeGroupTypes', data?: { __typename?: 'BrokerOfficeGroupData', groups?: Array<string> | null, key?: string | null } | null } | null } | null };

export type GetBrokersOnOfficeQueryVariables = Exact<{
  input?: InputMaybe<OfficeInput>;
}>;


export type GetBrokersOnOfficeQuery = { __typename?: 'Query', getOffice?: { __typename?: 'Office', id?: string | null, name?: string | null, brokers?: { __typename?: 'OfficeBrokers', list?: Array<{ __typename?: 'Broker', name?: string | null, email?: string | null, cellphone?: string | null, title?: string | null, path?: string | null, image?: { __typename?: 'BrokerImage', full?: string | null } | null } | null> | null } | null } | null };

export type GetCountiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountiesQuery = { __typename?: 'Query', counties?: { __typename?: 'SearchLocationsResult', list?: Array<{ __typename?: 'AggregatedItem', key?: string | null } | null> | null } | null };

export type GetMapPolygonsQueryVariables = Exact<{
  input: MapPolygonInput;
}>;


export type GetMapPolygonsQuery = { __typename?: 'Query', getMapPolygons?: { __typename?: 'AllMapPolygonResponse', count?: number | null, data?: Array<{ __typename?: 'MapDataItem', id?: number | null, name?: string | null, urltag?: string | null, zipcodes?: Array<string | null> | null, polygons?: Array<{ __typename?: 'MapPolygonItem', zipcode?: string | null, points?: Array<{ __typename?: 'MapPointItem', lat?: number | null, lng?: number | null } | null> | null } | null> | null } | null> | null } | null };

export type GetMuncipalitiesQueryVariables = Exact<{
  counties?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  useArea?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMuncipalitiesQuery = { __typename?: 'Query', getMunicipalities?: { __typename?: 'SearchLocationsResult', list?: Array<{ __typename?: 'AggregatedItem', key?: string | null } | null> | null } | null };

export type ProjectPricelistQueryVariables = Exact<{
  input?: InputMaybe<PropertyInput>;
}>;


export type ProjectPricelistQuery = { __typename?: 'Query', getProperty?: { __typename?: 'Property', id?: string | null, address?: string | null, units?: { __typename?: 'PropertyUnits', list?: { __typename?: 'AllPropertyUnits', all?: Array<{ __typename?: 'Property', id?: string | null, address?: string | null, bedrooms?: number | null, rooms?: number | null, floor?: number | null, type?: string | null, sold?: boolean | null, reserved?: boolean | null, published?: boolean | null, parking?: { __typename?: 'PropertyParking', list?: Array<{ __typename?: 'ParkingElement', id?: number | null, type_salgparkering?: string | null, benevnelse?: string | null } | null> | null } | null, bid?: { __typename?: 'PropertyBid', link?: { __typename?: 'Bid', url?: string | null } | null } | null, plot?: { __typename?: 'PropertyPlot', info?: { __typename?: 'Plot', size?: number | null } | null } | null, price?: { __typename?: 'PropertyPrice', info?: { __typename?: 'Price', price?: number | null, totalPrice?: number | null, commonCostsPeriode?: string | null, commonShareDebt?: number | null } | null } | null, area?: { __typename?: 'PropertyArea', bra?: string | null, prom?: string | null } | null, matrikkel?: { __typename?: 'PropertyMatrikkel', info?: { __typename?: 'Matrikkel', unit?: string | null } | null } | null, images?: { __typename?: 'PropertyImages', floorplan?: Array<{ __typename?: 'Image', url?: string | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type GetPropertyBoliglaanQueryVariables = Exact<{
  input?: InputMaybe<PropertyInput>;
}>;


export type GetPropertyBoliglaanQuery = { __typename?: 'Query', getProperty?: { __typename?: 'Property', address?: string | null, place?: string | null, ownerType?: string | null, area?: { __typename?: 'PropertyArea', prom?: string | null } | null, price?: { __typename?: 'PropertyPrice', info?: { __typename?: 'Price', price?: number | null } | null } | null, images?: { __typename?: 'PropertyImages', first?: { __typename?: 'Image', url?: string | null } | null } | null } | null };

export type GlobalSearchLandingpagesQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type GlobalSearchLandingpagesQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResult', result?: { __typename?: 'SearchResultSub', landingpages?: { __typename?: 'SearchResultLandingpages', total?: number | null, list?: Array<string | null> | null } | null } | null } | null };

export type LeisureSearchQueryVariables = Exact<{
  input?: InputMaybe<SearchInput>;
}>;


export type LeisureSearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResult', result?: { __typename?: 'SearchResultSub', properties?: { __typename?: 'SearchResultProperties', total?: number | null, aggregations?: { __typename?: 'PropertyAggregations', propertyTypes?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null, facilityTypes?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null, locationTypes?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null, counties?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null, municipalities?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null, municipalityAreas?: Array<{ __typename?: 'PropertyAggregationType', key?: string | null, doc_count?: number | null } | null> | null } | null, list?: Array<{ __typename?: 'SearchProperty', id?: string | null, address?: string | null, place?: string | null, type?: string | null, assignmentType?: string | null, sold?: boolean | null, checklistpoints?: { __typename?: 'SearchChecklistPointsInfo', info?: { __typename?: 'SearchChecklistPoints', pmExclusive?: boolean | null, teaser?: boolean | null } | null } | null, freetext?: { __typename?: 'PropertyFreeText', list?: { __typename?: 'PropertyFreeTextType', finnLocalArea?: string | null } | null } | null, office?: { __typename?: 'PropertyOffice', info?: { __typename?: 'Office', urltag?: string | null } | null } | null, images?: { __typename?: 'SearchPropertyImages', first?: { __typename?: 'SearchPropertyImage', url?: string | null } | null, list?: Array<{ __typename?: 'Image', url?: string | null } | null> | null } | null, location?: { __typename?: 'Location', municipality?: string | null, municipalityArea?: string | null, county?: string | null } | null, price?: { __typename?: 'PropertyPrice', info?: { __typename?: 'Price', price?: number | null, priceTo?: number | null } | null } | null, area?: { __typename?: 'PropertyArea', prom?: string | null, promTo?: string | null, bra?: string | null, braTo?: string | null } | null, units?: { __typename?: 'PropertyUnits', sold?: number | null, total?: number | null, available?: number | null } | null } | null> | null } | null } | null } | null };

export type GetAllNewsQueryVariables = Exact<{
  input: GetAllNewsInput;
}>;


export type GetAllNewsQuery = { __typename?: 'Query', getAllNews?: { __typename?: 'AllNewsResponse', total?: number | null, list?: Array<{ __typename?: 'News', title?: string | null, ingress?: string | null, slug?: string | null, image?: string | null } | null> | null } | null };

export type GetSingleNewsQueryVariables = Exact<{
  input: GetSingleNewsInput;
}>;


export type GetSingleNewsQuery = { __typename?: 'Query', getSingleNews?: { __typename?: 'SingleNewsResponse', title?: string | null, image?: string | null, imageDescriptionTop?: string | null, imageDescriptionBottom?: string | null, ingress?: string | null, body?: string | null, slug?: string | null } | null };

export type OfficeAboutQueryVariables = Exact<{
  input?: InputMaybe<OfficeInput>;
}>;


export type OfficeAboutQuery = { __typename?: 'Query', office?: { __typename?: 'Office', id?: string | null, name?: string | null, county?: string | null, municipality?: string | null, place?: string | null, zip?: string | null, about?: string | null, hasReferences?: boolean | null, referencesText?: string | null, referencesFormText?: string | null, seo?: { __typename?: 'OfficeSeo', title?: string | null, description?: string | null, image?: string | null } | null } | null };

export type GetReferenceQueryVariables = Exact<{
  input: GetReferencesInput;
}>;


export type GetReferenceQuery = { __typename?: 'Query', getReferences?: { __typename?: 'GetReferenceResponse', total?: number | null, list?: Array<{ __typename?: 'Reference', id?: number | null, name?: string | null, address?: string | null, text?: string | null, created?: string | null } | null> | null } | null };

export type OfficeHasReferencesQueryVariables = Exact<{
  input?: InputMaybe<OfficeInput>;
}>;


export type OfficeHasReferencesQuery = { __typename?: 'Query', getOffice?: { __typename?: 'Office', id?: string | null, hasReferences?: boolean | null } | null };

export type GetPageMapAreaBrokersQueryVariables = Exact<{
  input: PageBrokersInput;
}>;


export type GetPageMapAreaBrokersQuery = { __typename?: 'Query', getPageMapAreaBrokers: { __typename?: 'PageBrokersResult', count: number, list?: Array<{ __typename?: 'SingleBroker', name?: string | null, email?: string | null, cellphone?: string | null, title?: string | null, path?: string | null, offices?: { __typename?: 'BrokerOffices', list?: Array<{ __typename?: 'Office', id?: string | null, name?: string | null, urltag?: string | null } | null> | null } | null }> | null } };

export type GetPageMapAreasQueryVariables = Exact<{
  input: PageUrltagInput;
}>;


export type GetPageMapAreasQuery = { __typename?: 'Query', getPageMapAreas: { __typename?: 'PageAreasResult', count: number, list?: Array<{ __typename?: 'PageAreas', id?: number | null, name?: string | null }> | null } };

export type GetPageOfficesQueryVariables = Exact<{
  input: PageUrltagInput;
}>;


export type GetPageOfficesQuery = { __typename?: 'Query', getPageOffices: { __typename?: 'PageOfficeResult', count: number, list?: Array<{ __typename?: 'Office', name?: string | null, legalName?: string | null, address?: string | null, email?: string | null, urltag?: string | null, phone?: string | null }> | null } };

export type QuizQueryVariables = Exact<{
  input: QuizInput;
}>;


export type QuizQuery = { __typename?: 'Query', getQuizPage?: { __typename?: 'QuizPage', id?: number | null, mailType?: number | null, active?: boolean | null, rules?: string | null, formZipcode?: boolean | null, privacyPolicy?: string | null, seo?: { __typename?: 'QuizPageSeo', title?: string | null, content?: string | null, image?: string | null } | null, pageInit?: { __typename?: 'QuizPageContent', title?: string | null, ingress?: string | null, content?: string | null, image?: string | null } | null, pageThankyou?: { __typename?: 'QuizPageContent', title?: string | null, ingress?: string | null, content?: string | null, image?: string | null } | null, pageEnd?: { __typename?: 'QuizPageContent', title?: string | null, ingress?: string | null, content?: string | null, image?: string | null } | null } | null };

export type QuestionsQueryVariables = Exact<{
  input: QuizQuestionsInput;
}>;


export type QuestionsQuery = { __typename?: 'Query', getQuizQuestions?: Array<{ __typename?: 'QuizQuestion', text?: string | null, options?: Array<{ __typename?: 'QuizOption', id?: number | null, text?: string | null, letter?: string | null, pos?: number | null, isCorrect?: boolean | null } | null> | null } | null> | null };

export type GetConsentsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetConsentsByIdsQuery = { __typename?: 'Query', getAvailableSamtykkerByIds?: Array<{ __typename?: 'SamtykkeContainerResponse', id?: number | null, samtykketekst?: string | null } | null> | null };


export const LeadBoliglaanFinancingDocument = gql`
    mutation LeadBoliglaanFinancing($input: LeadInput!) {
  lead(input: $input) {
    financing {
      success
    }
  }
}
    `;
export type LeadBoliglaanFinancingMutationFn = Apollo.MutationFunction<LeadBoliglaanFinancingMutation, LeadBoliglaanFinancingMutationVariables>;

/**
 * __useLeadBoliglaanFinancingMutation__
 *
 * To run a mutation, you first call `useLeadBoliglaanFinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadBoliglaanFinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadBoliglaanFinancingMutation, { data, loading, error }] = useLeadBoliglaanFinancingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeadBoliglaanFinancingMutation(baseOptions?: Apollo.MutationHookOptions<LeadBoliglaanFinancingMutation, LeadBoliglaanFinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadBoliglaanFinancingMutation, LeadBoliglaanFinancingMutationVariables>(LeadBoliglaanFinancingDocument, options);
      }
export type LeadBoliglaanFinancingMutationHookResult = ReturnType<typeof useLeadBoliglaanFinancingMutation>;
export type LeadBoliglaanFinancingMutationResult = Apollo.MutationResult<LeadBoliglaanFinancingMutation>;
export type LeadBoliglaanFinancingMutationOptions = Apollo.BaseMutationOptions<LeadBoliglaanFinancingMutation, LeadBoliglaanFinancingMutationVariables>;
export const MailDocument = gql`
    mutation Mail($input: LeadInput!) {
  lead(input: $input) {
    mail {
      success
    }
  }
}
    `;
export type MailMutationFn = Apollo.MutationFunction<MailMutation, MailMutationVariables>;

/**
 * __useMailMutation__
 *
 * To run a mutation, you first call `useMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailMutation, { data, loading, error }] = useMailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailMutation(baseOptions?: Apollo.MutationHookOptions<MailMutation, MailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailMutation, MailMutationVariables>(MailDocument, options);
      }
export type MailMutationHookResult = ReturnType<typeof useMailMutation>;
export type MailMutationResult = Apollo.MutationResult<MailMutation>;
export type MailMutationOptions = Apollo.BaseMutationOptions<MailMutation, MailMutationVariables>;
export const OfficeValuationDocument = gql`
    mutation OfficeValuation($input: LeadInput!) {
  lead(input: $input) {
    valuation {
      success
    }
  }
}
    `;
export type OfficeValuationMutationFn = Apollo.MutationFunction<OfficeValuationMutation, OfficeValuationMutationVariables>;

/**
 * __useOfficeValuationMutation__
 *
 * To run a mutation, you first call `useOfficeValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfficeValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [officeValuationMutation, { data, loading, error }] = useOfficeValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfficeValuationMutation(baseOptions?: Apollo.MutationHookOptions<OfficeValuationMutation, OfficeValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfficeValuationMutation, OfficeValuationMutationVariables>(OfficeValuationDocument, options);
      }
export type OfficeValuationMutationHookResult = ReturnType<typeof useOfficeValuationMutation>;
export type OfficeValuationMutationResult = Apollo.MutationResult<OfficeValuationMutation>;
export type OfficeValuationMutationOptions = Apollo.BaseMutationOptions<OfficeValuationMutation, OfficeValuationMutationVariables>;
export const RegistrerBrukerSamtykkeDocument = gql`
    mutation RegistrerBrukerSamtykke($input: BrukerSamtykker!) {
  registrerBrukerSamtykke(input: $input) {
    success
  }
}
    `;
export type RegistrerBrukerSamtykkeMutationFn = Apollo.MutationFunction<RegistrerBrukerSamtykkeMutation, RegistrerBrukerSamtykkeMutationVariables>;

/**
 * __useRegistrerBrukerSamtykkeMutation__
 *
 * To run a mutation, you first call `useRegistrerBrukerSamtykkeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrerBrukerSamtykkeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrerBrukerSamtykkeMutation, { data, loading, error }] = useRegistrerBrukerSamtykkeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrerBrukerSamtykkeMutation(baseOptions?: Apollo.MutationHookOptions<RegistrerBrukerSamtykkeMutation, RegistrerBrukerSamtykkeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrerBrukerSamtykkeMutation, RegistrerBrukerSamtykkeMutationVariables>(RegistrerBrukerSamtykkeDocument, options);
      }
export type RegistrerBrukerSamtykkeMutationHookResult = ReturnType<typeof useRegistrerBrukerSamtykkeMutation>;
export type RegistrerBrukerSamtykkeMutationResult = Apollo.MutationResult<RegistrerBrukerSamtykkeMutation>;
export type RegistrerBrukerSamtykkeMutationOptions = Apollo.BaseMutationOptions<RegistrerBrukerSamtykkeMutation, RegistrerBrukerSamtykkeMutationVariables>;
export const GeneralValuationDocument = gql`
    mutation GeneralValuation($input: LeadInput!) {
  lead(input: $input) {
    valuation {
      success
      data {
        id
        address
        zip
        phone
        email
      }
    }
  }
}
    `;
export type GeneralValuationMutationFn = Apollo.MutationFunction<GeneralValuationMutation, GeneralValuationMutationVariables>;

/**
 * __useGeneralValuationMutation__
 *
 * To run a mutation, you first call `useGeneralValuationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneralValuationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generalValuationMutation, { data, loading, error }] = useGeneralValuationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneralValuationMutation(baseOptions?: Apollo.MutationHookOptions<GeneralValuationMutation, GeneralValuationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneralValuationMutation, GeneralValuationMutationVariables>(GeneralValuationDocument, options);
      }
export type GeneralValuationMutationHookResult = ReturnType<typeof useGeneralValuationMutation>;
export type GeneralValuationMutationResult = Apollo.MutationResult<GeneralValuationMutation>;
export type GeneralValuationMutationOptions = Apollo.BaseMutationOptions<GeneralValuationMutation, GeneralValuationMutationVariables>;
export const BrokerDocument = gql`
    query Broker($input: BrokerInput) {
  broker: getBroker(input: $input) {
    id
    name
    title
    email
    cellphone
    path
    helper
    properties {
      show
    }
    offices {
      list {
        title
        name
        urltag
        naering
      }
    }
    image {
      full
    }
    groupTypes {
      data {
        groups
        key
      }
    }
  }
}
    `;

/**
 * __useBrokerQuery__
 *
 * To run a query within a React component, call `useBrokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerQuery(baseOptions?: Apollo.QueryHookOptions<BrokerQuery, BrokerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerQuery, BrokerQueryVariables>(BrokerDocument, options);
      }
export function useBrokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerQuery, BrokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerQuery, BrokerQueryVariables>(BrokerDocument, options);
        }
export type BrokerQueryHookResult = ReturnType<typeof useBrokerQuery>;
export type BrokerLazyQueryHookResult = ReturnType<typeof useBrokerLazyQuery>;
export type BrokerQueryResult = Apollo.QueryResult<BrokerQuery, BrokerQueryVariables>;
export const GetBrokersOnOfficeDocument = gql`
    query GetBrokersOnOffice($input: OfficeInput) {
  getOffice(input: $input) {
    id
    name
    brokers {
      list {
        name
        image {
          full
        }
        email
        cellphone
        title
        path
      }
    }
  }
}
    `;

/**
 * __useGetBrokersOnOfficeQuery__
 *
 * To run a query within a React component, call `useGetBrokersOnOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokersOnOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokersOnOfficeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBrokersOnOfficeQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokersOnOfficeQuery, GetBrokersOnOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokersOnOfficeQuery, GetBrokersOnOfficeQueryVariables>(GetBrokersOnOfficeDocument, options);
      }
export function useGetBrokersOnOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokersOnOfficeQuery, GetBrokersOnOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokersOnOfficeQuery, GetBrokersOnOfficeQueryVariables>(GetBrokersOnOfficeDocument, options);
        }
export type GetBrokersOnOfficeQueryHookResult = ReturnType<typeof useGetBrokersOnOfficeQuery>;
export type GetBrokersOnOfficeLazyQueryHookResult = ReturnType<typeof useGetBrokersOnOfficeLazyQuery>;
export type GetBrokersOnOfficeQueryResult = Apollo.QueryResult<GetBrokersOnOfficeQuery, GetBrokersOnOfficeQueryVariables>;
export const GetCountiesDocument = gql`
    query GetCounties {
  counties: getAllCounties {
    list {
      key
    }
  }
}
    `;

/**
 * __useGetCountiesQuery__
 *
 * To run a query within a React component, call `useGetCountiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountiesQuery, GetCountiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountiesQuery, GetCountiesQueryVariables>(GetCountiesDocument, options);
      }
export function useGetCountiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountiesQuery, GetCountiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountiesQuery, GetCountiesQueryVariables>(GetCountiesDocument, options);
        }
export type GetCountiesQueryHookResult = ReturnType<typeof useGetCountiesQuery>;
export type GetCountiesLazyQueryHookResult = ReturnType<typeof useGetCountiesLazyQuery>;
export type GetCountiesQueryResult = Apollo.QueryResult<GetCountiesQuery, GetCountiesQueryVariables>;
export const GetMapPolygonsDocument = gql`
    query getMapPolygons($input: MapPolygonInput!) {
  getMapPolygons(input: $input) {
    count
    data {
      id
      name
      urltag
      zipcodes
      polygons {
        zipcode
        points {
          lat
          lng
        }
      }
    }
  }
}
    `;

/**
 * __useGetMapPolygonsQuery__
 *
 * To run a query within a React component, call `useGetMapPolygonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapPolygonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapPolygonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMapPolygonsQuery(baseOptions: Apollo.QueryHookOptions<GetMapPolygonsQuery, GetMapPolygonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapPolygonsQuery, GetMapPolygonsQueryVariables>(GetMapPolygonsDocument, options);
      }
export function useGetMapPolygonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapPolygonsQuery, GetMapPolygonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapPolygonsQuery, GetMapPolygonsQueryVariables>(GetMapPolygonsDocument, options);
        }
export type GetMapPolygonsQueryHookResult = ReturnType<typeof useGetMapPolygonsQuery>;
export type GetMapPolygonsLazyQueryHookResult = ReturnType<typeof useGetMapPolygonsLazyQuery>;
export type GetMapPolygonsQueryResult = Apollo.QueryResult<GetMapPolygonsQuery, GetMapPolygonsQueryVariables>;
export const GetMuncipalitiesDocument = gql`
    query GetMuncipalities($counties: [String], $useArea: Boolean) {
  getMunicipalities(counties: $counties, useArea: $useArea) {
    list {
      key
    }
  }
}
    `;

/**
 * __useGetMuncipalitiesQuery__
 *
 * To run a query within a React component, call `useGetMuncipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMuncipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMuncipalitiesQuery({
 *   variables: {
 *      counties: // value for 'counties'
 *      useArea: // value for 'useArea'
 *   },
 * });
 */
export function useGetMuncipalitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetMuncipalitiesQuery, GetMuncipalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMuncipalitiesQuery, GetMuncipalitiesQueryVariables>(GetMuncipalitiesDocument, options);
      }
export function useGetMuncipalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMuncipalitiesQuery, GetMuncipalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMuncipalitiesQuery, GetMuncipalitiesQueryVariables>(GetMuncipalitiesDocument, options);
        }
export type GetMuncipalitiesQueryHookResult = ReturnType<typeof useGetMuncipalitiesQuery>;
export type GetMuncipalitiesLazyQueryHookResult = ReturnType<typeof useGetMuncipalitiesLazyQuery>;
export type GetMuncipalitiesQueryResult = Apollo.QueryResult<GetMuncipalitiesQuery, GetMuncipalitiesQueryVariables>;
export const ProjectPricelistDocument = gql`
    query ProjectPricelist($input: PropertyInput) {
  getProperty(input: $input) {
    id
    address
    units {
      list {
        all {
          id
          address
          bedrooms
          rooms
          floor
          type
          sold
          reserved
          published
          parking {
            list {
              id
              type_salgparkering
              benevnelse
            }
          }
          bid {
            link {
              url
            }
          }
          plot {
            info {
              size
            }
          }
          price {
            info {
              price
              totalPrice
              commonCostsPeriode
              commonShareDebt
            }
          }
          area {
            bra
            prom
          }
          matrikkel {
            info {
              unit
            }
          }
          images {
            floorplan {
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectPricelistQuery__
 *
 * To run a query within a React component, call `useProjectPricelistQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPricelistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPricelistQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectPricelistQuery(baseOptions?: Apollo.QueryHookOptions<ProjectPricelistQuery, ProjectPricelistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPricelistQuery, ProjectPricelistQueryVariables>(ProjectPricelistDocument, options);
      }
export function useProjectPricelistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPricelistQuery, ProjectPricelistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPricelistQuery, ProjectPricelistQueryVariables>(ProjectPricelistDocument, options);
        }
export type ProjectPricelistQueryHookResult = ReturnType<typeof useProjectPricelistQuery>;
export type ProjectPricelistLazyQueryHookResult = ReturnType<typeof useProjectPricelistLazyQuery>;
export type ProjectPricelistQueryResult = Apollo.QueryResult<ProjectPricelistQuery, ProjectPricelistQueryVariables>;
export const GetPropertyBoliglaanDocument = gql`
    query GetPropertyBoliglaan($input: PropertyInput) {
  getProperty(input: $input) {
    address
    place
    ownerType
    area {
      prom
    }
    price {
      info {
        price
      }
    }
    images {
      first {
        url
      }
    }
  }
}
    `;

/**
 * __useGetPropertyBoliglaanQuery__
 *
 * To run a query within a React component, call `useGetPropertyBoliglaanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyBoliglaanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyBoliglaanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropertyBoliglaanQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyBoliglaanQuery, GetPropertyBoliglaanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyBoliglaanQuery, GetPropertyBoliglaanQueryVariables>(GetPropertyBoliglaanDocument, options);
      }
export function useGetPropertyBoliglaanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyBoliglaanQuery, GetPropertyBoliglaanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyBoliglaanQuery, GetPropertyBoliglaanQueryVariables>(GetPropertyBoliglaanDocument, options);
        }
export type GetPropertyBoliglaanQueryHookResult = ReturnType<typeof useGetPropertyBoliglaanQuery>;
export type GetPropertyBoliglaanLazyQueryHookResult = ReturnType<typeof useGetPropertyBoliglaanLazyQuery>;
export type GetPropertyBoliglaanQueryResult = Apollo.QueryResult<GetPropertyBoliglaanQuery, GetPropertyBoliglaanQueryVariables>;
export const GlobalSearchLandingpagesDocument = gql`
    query GlobalSearchLandingpages($input: SearchInput) {
  search(input: $input) {
    result {
      landingpages {
        total
        list
      }
    }
  }
}
    `;

/**
 * __useGlobalSearchLandingpagesQuery__
 *
 * To run a query within a React component, call `useGlobalSearchLandingpagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchLandingpagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchLandingpagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGlobalSearchLandingpagesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalSearchLandingpagesQuery, GlobalSearchLandingpagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalSearchLandingpagesQuery, GlobalSearchLandingpagesQueryVariables>(GlobalSearchLandingpagesDocument, options);
      }
export function useGlobalSearchLandingpagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchLandingpagesQuery, GlobalSearchLandingpagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalSearchLandingpagesQuery, GlobalSearchLandingpagesQueryVariables>(GlobalSearchLandingpagesDocument, options);
        }
export type GlobalSearchLandingpagesQueryHookResult = ReturnType<typeof useGlobalSearchLandingpagesQuery>;
export type GlobalSearchLandingpagesLazyQueryHookResult = ReturnType<typeof useGlobalSearchLandingpagesLazyQuery>;
export type GlobalSearchLandingpagesQueryResult = Apollo.QueryResult<GlobalSearchLandingpagesQuery, GlobalSearchLandingpagesQueryVariables>;
export const LeisureSearchDocument = gql`
    query LeisureSearch($input: SearchInput) {
  search(input: $input) {
    result {
      properties {
        total
        aggregations {
          propertyTypes {
            key
            doc_count
          }
          facilityTypes {
            key
            doc_count
          }
          locationTypes {
            key
            doc_count
          }
          counties {
            key
            doc_count
          }
          municipalities {
            key
            doc_count
          }
          municipalityAreas {
            key
            doc_count
          }
        }
        list {
          id
          address
          place
          type
          assignmentType
          sold
          checklistpoints {
            info {
              pmExclusive
              teaser
            }
          }
          freetext {
            list {
              finnLocalArea
            }
          }
          office {
            info {
              urltag
            }
          }
          images {
            first {
              url
            }
            list {
              url
            }
          }
          location {
            municipality
            municipalityArea
            county
          }
          price {
            info {
              price
              priceTo
            }
          }
          area {
            prom
            promTo
            bra
            braTo
          }
          units {
            sold
            total
            available
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLeisureSearchQuery__
 *
 * To run a query within a React component, call `useLeisureSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeisureSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeisureSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeisureSearchQuery(baseOptions?: Apollo.QueryHookOptions<LeisureSearchQuery, LeisureSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeisureSearchQuery, LeisureSearchQueryVariables>(LeisureSearchDocument, options);
      }
export function useLeisureSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeisureSearchQuery, LeisureSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeisureSearchQuery, LeisureSearchQueryVariables>(LeisureSearchDocument, options);
        }
export type LeisureSearchQueryHookResult = ReturnType<typeof useLeisureSearchQuery>;
export type LeisureSearchLazyQueryHookResult = ReturnType<typeof useLeisureSearchLazyQuery>;
export type LeisureSearchQueryResult = Apollo.QueryResult<LeisureSearchQuery, LeisureSearchQueryVariables>;
export const GetAllNewsDocument = gql`
    query GetAllNews($input: GetAllNewsInput!) {
  getAllNews(input: $input) {
    total
    list {
      title
      ingress
      slug
      image
    }
  }
}
    `;

/**
 * __useGetAllNewsQuery__
 *
 * To run a query within a React component, call `useGetAllNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllNewsQuery(baseOptions: Apollo.QueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
      }
export function useGetAllNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
        }
export type GetAllNewsQueryHookResult = ReturnType<typeof useGetAllNewsQuery>;
export type GetAllNewsLazyQueryHookResult = ReturnType<typeof useGetAllNewsLazyQuery>;
export type GetAllNewsQueryResult = Apollo.QueryResult<GetAllNewsQuery, GetAllNewsQueryVariables>;
export const GetSingleNewsDocument = gql`
    query GetSingleNews($input: GetSingleNewsInput!) {
  getSingleNews(input: $input) {
    title
    image
    imageDescriptionTop
    imageDescriptionBottom
    ingress
    body
    slug
  }
}
    `;

/**
 * __useGetSingleNewsQuery__
 *
 * To run a query within a React component, call `useGetSingleNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleNewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSingleNewsQuery(baseOptions: Apollo.QueryHookOptions<GetSingleNewsQuery, GetSingleNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleNewsQuery, GetSingleNewsQueryVariables>(GetSingleNewsDocument, options);
      }
export function useGetSingleNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleNewsQuery, GetSingleNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleNewsQuery, GetSingleNewsQueryVariables>(GetSingleNewsDocument, options);
        }
export type GetSingleNewsQueryHookResult = ReturnType<typeof useGetSingleNewsQuery>;
export type GetSingleNewsLazyQueryHookResult = ReturnType<typeof useGetSingleNewsLazyQuery>;
export type GetSingleNewsQueryResult = Apollo.QueryResult<GetSingleNewsQuery, GetSingleNewsQueryVariables>;
export const OfficeAboutDocument = gql`
    query OfficeAbout($input: OfficeInput) {
  office: getOffice(input: $input) {
    id
    name
    county
    municipality
    place
    zip
    about
    hasReferences
    referencesText
    referencesFormText
    seo {
      title
      description
      image
    }
  }
}
    `;

/**
 * __useOfficeAboutQuery__
 *
 * To run a query within a React component, call `useOfficeAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeAboutQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfficeAboutQuery(baseOptions?: Apollo.QueryHookOptions<OfficeAboutQuery, OfficeAboutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeAboutQuery, OfficeAboutQueryVariables>(OfficeAboutDocument, options);
      }
export function useOfficeAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeAboutQuery, OfficeAboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeAboutQuery, OfficeAboutQueryVariables>(OfficeAboutDocument, options);
        }
export type OfficeAboutQueryHookResult = ReturnType<typeof useOfficeAboutQuery>;
export type OfficeAboutLazyQueryHookResult = ReturnType<typeof useOfficeAboutLazyQuery>;
export type OfficeAboutQueryResult = Apollo.QueryResult<OfficeAboutQuery, OfficeAboutQueryVariables>;
export const GetReferenceDocument = gql`
    query GetReference($input: GetReferencesInput!) {
  getReferences(input: $input) {
    total
    list {
      id
      name
      address
      text
      created
    }
  }
}
    `;

/**
 * __useGetReferenceQuery__
 *
 * To run a query within a React component, call `useGetReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetReferenceQuery, GetReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferenceQuery, GetReferenceQueryVariables>(GetReferenceDocument, options);
      }
export function useGetReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferenceQuery, GetReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferenceQuery, GetReferenceQueryVariables>(GetReferenceDocument, options);
        }
export type GetReferenceQueryHookResult = ReturnType<typeof useGetReferenceQuery>;
export type GetReferenceLazyQueryHookResult = ReturnType<typeof useGetReferenceLazyQuery>;
export type GetReferenceQueryResult = Apollo.QueryResult<GetReferenceQuery, GetReferenceQueryVariables>;
export const OfficeHasReferencesDocument = gql`
    query OfficeHasReferences($input: OfficeInput) {
  getOffice(input: $input) {
    id
    hasReferences
  }
}
    `;

/**
 * __useOfficeHasReferencesQuery__
 *
 * To run a query within a React component, call `useOfficeHasReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeHasReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeHasReferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfficeHasReferencesQuery(baseOptions?: Apollo.QueryHookOptions<OfficeHasReferencesQuery, OfficeHasReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeHasReferencesQuery, OfficeHasReferencesQueryVariables>(OfficeHasReferencesDocument, options);
      }
export function useOfficeHasReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeHasReferencesQuery, OfficeHasReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeHasReferencesQuery, OfficeHasReferencesQueryVariables>(OfficeHasReferencesDocument, options);
        }
export type OfficeHasReferencesQueryHookResult = ReturnType<typeof useOfficeHasReferencesQuery>;
export type OfficeHasReferencesLazyQueryHookResult = ReturnType<typeof useOfficeHasReferencesLazyQuery>;
export type OfficeHasReferencesQueryResult = Apollo.QueryResult<OfficeHasReferencesQuery, OfficeHasReferencesQueryVariables>;
export const GetPageMapAreaBrokersDocument = gql`
    query getPageMapAreaBrokers($input: PageBrokersInput!) {
  getPageMapAreaBrokers(input: $input) {
    count
    list {
      name
      email
      cellphone
      title
      path
      offices {
        list {
          id
          name
          urltag
        }
      }
    }
  }
}
    `;

/**
 * __useGetPageMapAreaBrokersQuery__
 *
 * To run a query within a React component, call `useGetPageMapAreaBrokersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageMapAreaBrokersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageMapAreaBrokersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPageMapAreaBrokersQuery(baseOptions: Apollo.QueryHookOptions<GetPageMapAreaBrokersQuery, GetPageMapAreaBrokersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageMapAreaBrokersQuery, GetPageMapAreaBrokersQueryVariables>(GetPageMapAreaBrokersDocument, options);
      }
export function useGetPageMapAreaBrokersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageMapAreaBrokersQuery, GetPageMapAreaBrokersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageMapAreaBrokersQuery, GetPageMapAreaBrokersQueryVariables>(GetPageMapAreaBrokersDocument, options);
        }
export type GetPageMapAreaBrokersQueryHookResult = ReturnType<typeof useGetPageMapAreaBrokersQuery>;
export type GetPageMapAreaBrokersLazyQueryHookResult = ReturnType<typeof useGetPageMapAreaBrokersLazyQuery>;
export type GetPageMapAreaBrokersQueryResult = Apollo.QueryResult<GetPageMapAreaBrokersQuery, GetPageMapAreaBrokersQueryVariables>;
export const GetPageMapAreasDocument = gql`
    query getPageMapAreas($input: PageUrltagInput!) {
  getPageMapAreas(input: $input) {
    count
    list {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPageMapAreasQuery__
 *
 * To run a query within a React component, call `useGetPageMapAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageMapAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageMapAreasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPageMapAreasQuery(baseOptions: Apollo.QueryHookOptions<GetPageMapAreasQuery, GetPageMapAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageMapAreasQuery, GetPageMapAreasQueryVariables>(GetPageMapAreasDocument, options);
      }
export function useGetPageMapAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageMapAreasQuery, GetPageMapAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageMapAreasQuery, GetPageMapAreasQueryVariables>(GetPageMapAreasDocument, options);
        }
export type GetPageMapAreasQueryHookResult = ReturnType<typeof useGetPageMapAreasQuery>;
export type GetPageMapAreasLazyQueryHookResult = ReturnType<typeof useGetPageMapAreasLazyQuery>;
export type GetPageMapAreasQueryResult = Apollo.QueryResult<GetPageMapAreasQuery, GetPageMapAreasQueryVariables>;
export const GetPageOfficesDocument = gql`
    query getPageOffices($input: PageUrltagInput!) {
  getPageOffices(input: $input) {
    count
    list {
      name
      legalName
      name
      address
      email
      urltag
      phone
    }
  }
}
    `;

/**
 * __useGetPageOfficesQuery__
 *
 * To run a query within a React component, call `useGetPageOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageOfficesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPageOfficesQuery(baseOptions: Apollo.QueryHookOptions<GetPageOfficesQuery, GetPageOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageOfficesQuery, GetPageOfficesQueryVariables>(GetPageOfficesDocument, options);
      }
export function useGetPageOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageOfficesQuery, GetPageOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageOfficesQuery, GetPageOfficesQueryVariables>(GetPageOfficesDocument, options);
        }
export type GetPageOfficesQueryHookResult = ReturnType<typeof useGetPageOfficesQuery>;
export type GetPageOfficesLazyQueryHookResult = ReturnType<typeof useGetPageOfficesLazyQuery>;
export type GetPageOfficesQueryResult = Apollo.QueryResult<GetPageOfficesQuery, GetPageOfficesQueryVariables>;
export const QuizDocument = gql`
    query quiz($input: QuizInput!) {
  getQuizPage(input: $input) {
    id
    mailType
    active
    seo {
      title
      content
      image
    }
    pageInit {
      title
      ingress
      content
      image
    }
    pageThankyou {
      title
      ingress
      content
      image
    }
    pageEnd {
      title
      ingress
      content
      image
    }
    rules
    formZipcode
    privacyPolicy
  }
}
    `;

/**
 * __useQuizQuery__
 *
 * To run a query within a React component, call `useQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuizQuery(baseOptions: Apollo.QueryHookOptions<QuizQuery, QuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuizQuery, QuizQueryVariables>(QuizDocument, options);
      }
export function useQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuizQuery, QuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuizQuery, QuizQueryVariables>(QuizDocument, options);
        }
export type QuizQueryHookResult = ReturnType<typeof useQuizQuery>;
export type QuizLazyQueryHookResult = ReturnType<typeof useQuizLazyQuery>;
export type QuizQueryResult = Apollo.QueryResult<QuizQuery, QuizQueryVariables>;
export const QuestionsDocument = gql`
    query questions($input: QuizQuestionsInput!) {
  getQuizQuestions(input: $input) {
    text
    options {
      id
      text
      letter
      pos
      isCorrect
    }
  }
}
    `;

/**
 * __useQuestionsQuery__
 *
 * To run a query within a React component, call `useQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuestionsQuery(baseOptions: Apollo.QueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
      }
export function useQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export type QuestionsQueryHookResult = ReturnType<typeof useQuestionsQuery>;
export type QuestionsLazyQueryHookResult = ReturnType<typeof useQuestionsLazyQuery>;
export type QuestionsQueryResult = Apollo.QueryResult<QuestionsQuery, QuestionsQueryVariables>;
export const GetConsentsByIdsDocument = gql`
    query GetConsentsByIds($ids: [Int]) {
  getAvailableSamtykkerByIds(ids: $ids) {
    id
    samtykketekst
  }
}
    `;

/**
 * __useGetConsentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetConsentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsentsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetConsentsByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetConsentsByIdsQuery, GetConsentsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsentsByIdsQuery, GetConsentsByIdsQueryVariables>(GetConsentsByIdsDocument, options);
      }
export function useGetConsentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsentsByIdsQuery, GetConsentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsentsByIdsQuery, GetConsentsByIdsQueryVariables>(GetConsentsByIdsDocument, options);
        }
export type GetConsentsByIdsQueryHookResult = ReturnType<typeof useGetConsentsByIdsQuery>;
export type GetConsentsByIdsLazyQueryHookResult = ReturnType<typeof useGetConsentsByIdsLazyQuery>;
export type GetConsentsByIdsQueryResult = Apollo.QueryResult<GetConsentsByIdsQuery, GetConsentsByIdsQueryVariables>;